var vowProduct = null
$(".filter_toggle").click(function(){
  $(this).find('.filter__icon').toggleClass('hide')
  $(this).find('.close__icon').toggleClass('show')
  $('#filter_show_hide').toggleClass('show')
});

// Getting Slider's By ID
var isSelectDiamondFirst = getParameterByName("selectDiamondFirst");
var rangeSlider = document.getElementById('slider-range');
var rangeSlider2 = document.getElementById('slider-range2');
var ratioSlider = document.getElementById('ratio-slider-range');
var colorSlider = document.getElementById('colorSlider');
var fluorescenceSlider = document.getElementById('fluorescenceSlider');
var claritySlider = document.getElementById('claritySlider');
var allPrice = []
var allCarats = []

// Initialize slider:
var filterApplied = false
$(document).ready(function() {
  setTimeout(function () {
    generateFeedData();
  }, 50);
  $(".additional-param-link").click(function(){
    var isAdditionalDropDownOpen = !$(".additional-param-link").find(".priceSortIcon").hasClass("priceSortIcon-rotate");
    if(filterApplied == true){
      localStorage.setItem("_isDrawerOpened", isAdditionalDropDownOpen)
    } else {
      localStorage.setItem("_isDrawerOpened", isAdditionalDropDownOpen)
    }
  })
  /* ===== Checking Page Number and scrolling the user to the top of the page */
  var getPageNumber = getParameterByName('page');
  if (!getPageNumber) {
    window.scrollTo({top: 0, behavior: 'smooth'})
  }
});

function getIcons(action) {
  var icons = '';
  if (iconsWithName.hasOwnProperty(action)) {
    icons = iconsWithName[action]
  }
  return icons;
}

function generateFeedData(){
  // Updating the page by getting parameters
  $(".siteLoader").show()
  var productHandle = getParameterByName("productHandle");
  var checkSelectDiamondFirst = getParameterByName("selectDiamondFirst");
  if (productHandle) {
    fetch("/collections/all/products/"+productHandle+".json", {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      }
    })
    .then(response => response.json())
    .then((data) => {
      vowProduct = data.product
      return vowProduct
    })
    .then(function(data) {
      /** Setting a diamond Shape **/
      var tmpDiamondShape = getDiamondType()
      if(!tmpDiamondShape) {
        tmpDiamondShape = data.variants[0].option1
      }
      let diamondShape = getDiamondOtherNames(tmpDiamondShape)[0]
      var globArr = [];
      var url = new URL(window.location.href);
      var allDiamondType = decodeURIComponent(url.searchParams.get("diamondType"));
      var answ = allDiamondType.split(',');
      answ.forEach(function(obj){
        globArr.push(obj);
      });
      setDiamond(globArr);
      generateSliders(diamondShape, '');
      getRapnetFeed();
      return data
    })
    .then(function(data) {
      /** Setting the diamond Shape **/
      if (data.options.length > 0) {
        let diamondNames = []
        data.options.map(function(d, i) {
          if (d.name && (d.name == "Diamond Shape" || d.name == "Shape")) {
            diamondNames = d.values
          }
        })
        return diamondNames
      } else {
        console.log("diamondNames are null")
      }
    })
    .then(function(diamonds) {
      if (diamonds.length > 0) {
        /* For lab Antique diamonds disabling the options */
        let diamondLabType = getParameterByName('diamondLabType') 
        let selectedInfo = JSON.parse(localStorage.getItem('selectedSettingInfo') || "{}");
        let hideMarquiseDiamond = selectedInfo.hideMarquiseDiamond === true;         
        let diamondsString = ''
        let diamondsOptionString = ''
        diamonds.map(function(diamond, i) {
          /* Disabling the anchor tag button */
          let isDiamondDisabled = false
          if( (diamond == "Antique-Style Round" || diamond == "Antique-Style Cushion") && diamondLabType && diamondLabType == "lab" ) {
            isDiamondDisabled = true
          }
          /* Excluding the princess diamond */
          if (diamond.toLowerCase() === "princess") {
            return;
          }
          /* Excluding Marquise if hideMarquiseDiamond = true */
          if (hideMarquiseDiamond && diamond.toLowerCase() === "marquise") {
            return;
          }
          let icon = getIcons(diamond)
          /* Options string */
          diamondsOptionString += `<label><input class="custom-feed-label" type="checkbox" onclick="getFeedByDiamondForMobile(this)" name="${diamond}" value="${diamond}" />${diamond}</label>`
          /* Li string */
          diamondsString += `<li data-val="${diamond}">
            <a onclick="getFeedByDiamond(this)" title="${diamond}" data-label="${diamond}" class="diamondShapes ${isDiamondDisabled == true ? "disabled" : ""}" href="javascript:void(0)" data-value="${diamond}">
              ${icon}
            </a>
            <span class="diamond-feed-shapes diamond-shape-name ${diamond}" id="diamond-shape-name-${diamond}">${diamond}</span>
          </li>`
        })
        $("#engaged").html(diamondsOptionString)
        $(".product-item-diamond-shape").html(diamondsString)
      } else {
        console.log(diamonds, "No diamonds are present")
      }
    })
    .then(function() {
      let tmpDiamondShape = getDiamond()
      let diamondLabType = getParameterByName('diamondLabType') 
      let isDiamondDisabled = false
      /* Setting the diamond shape in list and dropdown */
      $("ul.product-item-diamond-shape li").removeClass("active")
      var arr = [];
      tmpDiamondShape.map(shape => {
        if( (shape == "Antique-Style Round" || shape == "Antique-Style Cushion") && diamondLabType && diamondLabType == "lab" ) {
          isDiamondDisabled = true
        }
        if(isDiamondDisabled === false) {
          $("ul.product-item-diamond-shape").find(`li[data-val="${shape}"]`).addClass("active");
          arr.push(shape)
          if(shape === 'Antique-Style Cushion' || shape === 'Antique-Style Round') {
            $('.filter__section').addClass('filter__section__space')
            $('.diamond__shape').addClass('diamond__shape__space')
          }
        }
      });
      if((arr.toString() == tmpDiamondShape.toString()) == false) feedOnDiamondChange(arr)
      $("#engaged").val(tmpDiamondShape)
      setTips()
    })
  } else if(checkSelectDiamondFirst === 'true') {
    var allDiamonds= ["Oval","Round","Emerald","Pear","Marquise","Radiant","Cushion","Antique-Style Cushion","Antique-Style Round"]
    var diamondShape = getDiamondOtherNames("Round")[0]
    var globArr = [];
    var url = new URL(window.location.href);
    var allDiamondType = decodeURIComponent(url.searchParams.get("diamondType"));
    var answ = allDiamondType.split(',');
    answ.forEach(function(obj){
      globArr.push(obj);
    });
    setDiamond(globArr); /* Setting up Diamonds: Selected */
    /* Re-initializing local-storage data for selected Diamond shapes */
    let storageEntry = localStorage.getItem('_bodyToSend');
    if (storageEntry && storageEntry !== null) {
      let storageObject = JSON.parse(storageEntry);
      storageObject.shapes = globArr
      let updatedStorageEntry = JSON.stringify(storageObject);
      localStorage.setItem('_bodyToSend', updatedStorageEntry);
    }
    generateSliders(diamondShape, '');
    getRapnetFeed();
    if (allDiamonds.length > 0) {
      /* For lab Antique diamonds disabling the options */
      let diamondLabType = getParameterByName('diamondLabType')          
      let diamondsString = ''
      let diamondsOptionString = ''
      allDiamonds.map(function(diamond, i) {
        /* Disabling the anchor tag button */
        let isDiamondDisabled = false
        if( (diamond == "Antique-Style Round" || diamond == "Antique-Style Cushion") && diamondLabType && diamondLabType == "lab" ) {
          isDiamondDisabled = true
        }
        /* Excluding the princess diamond */
        if (diamond.toLowerCase() === "princess") {
          return;
        }
        let icon = getIcons(diamond)
        /* Options string */
        diamondsOptionString += `<label><input class="custom-feed-label" type="checkbox" onclick="getFeedByDiamondForMobile(this)" name="${diamond}" value="${diamond}" />${diamond}</label>`
        
        /* Li string */
        diamondsString += `<li data-val="${diamond}">
          <a onclick="getFeedByDiamond(this)" title="${diamond}" data-label="${diamond}" class="diamondShapes ${isDiamondDisabled == true ? "disabled" : ""}" href="javascript:void(0)" data-value="${diamond}">
            ${icon}
          </a>
          <span class="diamond-feed-shapes diamond-shape-name ${diamond}" id="diamond-shape-name-${diamond}">${diamond}</span>
        </li>`
      })
      $("#engaged").html(diamondsOptionString)
      $(".product-item-diamond-shape").html(diamondsString)

      let tmpDiamondShape = getDiamond()
      let isDiamondDisabled = false
      /* Setting the diamond shape in list and dropdown */
      $("ul.product-item-diamond-shape li").removeClass("active")
      var arr = [];
      tmpDiamondShape.map(shape => {
        if( (shape == "Antique-Style Round" || shape == "Antique-Style Cushion") && diamondLabType && diamondLabType == "lab" ) {
          isDiamondDisabled = true
        }
        if(isDiamondDisabled === false) {
          $("ul.product-item-diamond-shape").find(`li[data-val="${shape}"]`).addClass("active");
          arr.push(shape)
          if(shape === 'Antique-Style Cushion' || shape === 'Antique-Style Round') {
            $('.filter__section').addClass('filter__section__space')
            $('.diamond__shape').addClass('diamond__shape__space')
          }
        }
      });
      if((arr.toString() == tmpDiamondShape.toString()) == false) feedOnDiamondChange(arr)
      $("#engaged").val(tmpDiamondShape)
      setTips()
    } else {
      console.log(allDiamonds, "No diamonds are present")
    }
  } else {
    console.log("productHandle is required")
  }

  $('.noUi-handle').on('click', function() {
    $(this).width(50);
  });

  // Adding dynamic class on popup scroll
  $(window).scroll(function() {
    var position = $(".diamond__section").position();
    if(position && position.top <= window.scrollY) {
      $(".diamond__left").addClass("diamond__left__fixed");
      $(".diamond__right").addClass("diamond__right__fixed");
    } else {
      $(".diamond__left").removeClass("diamond__left__fixed");
      $(".diamond__right").removeClass("diamond__right__fixed");
    }
  });
}

// Global object to send data to Rapnet api
var bodyToSend = {
  "page_number": 1,
  "page_size": 100,
  "sort_by": "Size",
  "sort_direction": "Asc",
  "price_total_from": getParameterByName('diamondLabType') === 'natural' ? minNaturalDiamondPrice : minLabGrownDiamondPrice,
  "price_total_to": getParameterByName('diamondLabType') === 'natural' ? maxNaturalDiamondPrice : maxLabGrownDiamondPrice,
  "lg": false
}
var defaultDiamondShape = null;
var diamondsInfoApiUrl = storePrivateApiUrl+'/feeds';
var polishToolTip = '';
var symmetryToolTip = '';
var flToolTip = '';
var callRapnetFeed = true;
var sortOrder = {
  carat: 'Asc',
  color: 'Asc',
  clarity: 'Asc',
  price: 'Asc'
}

function setTips() {
  polishToolTip = `<div class="info-window">`
     +getIcons('Question')+`
     <div class="info-window-contain left-tooltip diamondtips">
        The overall smoothness and condition of the diamond’s surface. A well polished diamond produces crisp reflections and maximized light transmission.
     </div>
  </div>`;
  symmetryToolTip = `<div class="info-window">`
     +getIcons('Question')+`
     <div class="info-window-contain left-tooltip diamondtips">
        The exactness of shape and alignment of individual facets. A diamond with excellent symmetry will have beautiful brilliance.
     </div>
  </div>`;
  flToolTip = `<div class="info-window">`
     +getIcons('Question')+`
     <div class="info-window-contain left-tooltip diamondtips">
        A diamond's fluorescence grade refers to the intensity of the diamond’s reaction to UV light (like black light). The GIA conducted a study which concluded that none to medium fluorescence has no negative impact on a diamond's appearance, which is why we only work with none-medium fluorescence grades. This study also found that some fluorescence can make IJK color diamonds appear whiter.
     </div>
  </div>`;
}

function setDiamond(diamond) {
  defaultDiamondShape = diamond
}

function getDiamond() {
  var url = new URL(window.location.href);
  var allDiamondType = decodeURIComponent(url.searchParams.get("diamondType"));
  var answ = allDiamondType.split(',');
  if (!defaultDiamondShape) {
    defaultDiamondShape = answ;
    setDiamond(answ);
  }
  return Array.isArray(defaultDiamondShape) ? defaultDiamondShape : [defaultDiamondShape];
}

function callApi(url, data) {
  return fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(data)
  })
  .then(response => response.json())
  .then((data) => {
    return data.response.body
  })
}

function getColorFromNumber(number) {
  let color = ''
  if(number == "$4") {
    color = 'D'
  } else if(number == "$5") {
    color = 'E'
  } else if(number == "$6") {
    color = 'F'
  } else if(number == "$7") {
    color = 'G'
  } else if(number == "$8") {
    color = 'H'
  } else if(number == "$9") {
    color = 'I'
  } else if(number == "$10") {
    color = 'J'
  } else if(number == "$11") {
    color = 'K'
  } else if(number == "$12") {
    color = 'L'
  } else if(number == "$13") {
    color = 'M'
  }
  return color;
}

function getClarityFromNumber(number) {
  let color = ''
  if(number == "$0") {
    color = 'IF'
  } else if(number == "$1") {
    color = 'IF'
  } else if(number == "$2") {
    color = 'VVS1'
  } else if(number == "$3") {
    color = 'VVS2'
  } else if(number == "$4") {
    color = 'VS1'
  } else if(number == "$5") {
    color = 'VS2'
  } else if(number == "$6") {
    color = 'SI1'
  } else if(number == "$7") {
    color = 'SI2'
  } else if(number == "$8") {
    color = 'SI3'
  } else if(number == "$9") {
    color = 'I1'
  } else if(number == "$10") {
    color = 'I2'
  } else if(number == "$11") {
    color = 'I3'
  }
  return color;
}

/* Setting Values for Fluorecence */
function getFluorescenceFromArray(number, sliderArrayFluaorance) {
  var fetchFluorescenceData = []
  /* Fluorescence Slider Values */
  var stepOne = parseInt(number[0].replace("$",""))
  var stepTwo = parseInt(number[1].replace("$",""))
  var valueToSendOne = sliderArrayFluaorance[stepOne - 1] ? sliderArrayFluaorance[stepOne - 1] : sliderArrayFluaorance[sliderArrayFluaorance.length - 1]
  var valueToSendTwo = sliderArrayFluaorance[stepTwo - 2] ? sliderArrayFluaorance[stepTwo - 2] : sliderArrayFluaorance[0]
  /* Fetching selected Value from the Fluorescence Array */
  fetchFluorescenceData.push(valueToSendOne,valueToSendTwo)
  /* Sending Blank Array for Default(1,4) */
  if(stepOne === 1 && stepTwo === (sliderArrayFluaorance.length + 1)) fetchFluorescenceData = [] 
  return fetchFluorescenceData
} 
  
function callApiAsPerDiamond(diamondShape, dataToSend, type='') {
  // If diamond lab type is set and it is equal to lab then set parameter
  jQuery(".filter-btn").removeClass("active")
  let defaultDiamondLabType = getParameterByName('diamondLabType')
  let getDiamondType = getParameterByName('diamondType')
  var checkSelectDiamondFirst = getParameterByName("selectDiamondFirst");
  if( defaultDiamondLabType && defaultDiamondLabType == "lab") {
    bodyToSend.lg = true
    jQuery('.filter-btn[data-labdiamond="true"]').addClass("active")
  } else {
    jQuery('.filter-btn[data-labdiamond="false"]').addClass("active")
  }
  // Returning promise
  return new Promise(function(resolve, reject) {
    if( true || diamondShape == "European" || diamondShape == "Old Mine" ||
      diamondShape == "Old Cut Round" || diamondShape == "Old Cut Cushion") {
      let urlToCall = storePrivateApiUrl+'/diamonds/feedv3';
      if(window.location.href.includes('page=')) {
        let pageNo = (window.location.href.split('&page=')[1]).split('&')[0]
        dataToSend.page_number = pageNo
      }
      if (checkSelectDiamondFirst === 'true' && (getDiamondType === `""` || getDiamondType === 'null' || getDiamondType === null)) {
        dataToSend.shapes = ["Oval","Round","Emerald","Pear","Marquise","Radiant","Cushion","Antique-Style Cushion","Antique-Style Round"]
      }
      if (diamondShape.includes("Antique-Style Round")) {
        diamondShape = diamondShape.map(shape =>
          shape === "Antique-Style Round" ? "Antique-Style Round" : shape
        );
        dataToSend.shapes = diamondShape
      }
      if (diamondShape.includes("Emerald (East/West)") || diamondShape.includes("Emerald (North/South)")) {
        diamondShape = diamondShape.map(shape =>
          shape === "Emerald (East/West)" || shape === "Emerald (North/South)"
            ? "Emerald"
            : shape
        );
        dataToSend.shapes = diamondShape;
      }
      
      fetch(urlToCall, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(dataToSend)
      })
      .then(response => response.json())
      .then((res) => {
        resolve(res.response.body)
      })
    } else {
      callApi(diamondsInfoApiUrl, dataToSend)
      .then((res) => {
        resolve(res)
      })
      .catch((error) => {
        reject(error)
      })
    }
  })
}

function getDiamondMaxMinInfo(diamondShape, cb) {
  var grabDiamondShapes = getDiamond()
  let dataToSend = {
    shapes: grabDiamondShapes,
    page_number: 1,
    page_size: 1
  }
  if (grabDiamondShapes.includes("Antique-Style Round")) {
    grabDiamondShapes = grabDiamondShapes.map(shape =>
      shape === "Antique-Style Round" ? "Antique-Style Round" : shape
    );
    dataToSend.shapes = grabDiamondShapes
  }
  if (grabDiamondShapes.includes("Emerald (East/West)") || grabDiamondShapes.includes("Emerald (North/South)")) {
    grabDiamondShapes = grabDiamondShapes.map(shape =>
      shape === "Emerald (East/West)" || shape === "Emerald (North/South)"
        ? "Emerald"
        : shape
    );
    dataToSend.shapes = grabDiamondShapes;
  }
  let diamondLabType = getParameterByName('diamondLabType')
  if( diamondLabType && diamondLabType == "lab" ) {
    dataToSend.lg = true
  } else {
    dataToSend.lg = false
  }
  let returnData = { maxPrice: null, minPrice: null, maxCarat: null, minCarat: null, clarity: null, maxColor: null }
  fetch(storePrivateApiUrl+'/diamonds/feedv3?for=maxandmin', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(dataToSend)
  })
  .then(response => response.json())
  .then((res) => {
    return res.response.ranges
  })
  .then((ranges) => {
    returnData['minPrice'] = ranges.minPrice
    returnData['maxPrice'] = ranges.maxPrice
    returnData['minCarat'] = ranges.minSize
    returnData['maxCarat'] = ranges.maxSize
    returnData['clarity']  = ranges.clarity
    returnData['color']    = ranges.maxColor
    return returnData
  })
  .then(function() {
    cb(null, returnData)
  })
  .catch(function(e) {
    cb(e, null)
  })
}

function requestParameterByDiamondName(name) {
  var json = {
    symmetry_from: "Excellent",
    color_from: "D",
    polish_from: "Excellent",
    polish_to: "Good",
    clarity_from: "IF",
    clarity_to: "SI2",
    fluorescence_intensities: ["Medium", "Faint", "None"]
  }
  if (name == "Round") {
    json.shapes = ['Round']
    json.symmetry_to = "Excellent"
    json.polish_to = "Excellent"
    json.cut_from = "Excellent"
    json.cut_to = "Excellent"
    json.color_to = "J"
  } else if (name == "Oval") {
    json.shapes = ['Oval']
    json.symmetry_to = "Good"
    json.color_to = "J"
  } else if (name == "Cushion") {
    json.shapes = ['Cushion']
    json.symmetry_to = "Good"
    json.color_to = "J"
  } else if (name == "Pear") {
    json.shapes = ['Pear']
    json.symmetry_to = "Good"
    json.color_to = "J"
  } else if (name == "Radiant") {
    json.shapes = ['Radiant']
    json.symmetry_to = "Good"
    json.color_to = "J"
  } else if (name == "Emerald") {
    json.shapes = ['Emerald']
    json.symmetry_to = "Good"
    json.clarity_to = "VS2"
    json.color_to = "J"
  } else if (name === 'Old Cut Round' || name === 'Antique-Style Round') {
    json.shapes = ['Old Cut Round']
    json.symmetry_to = "Fair"
    json.color_to = "K"
  } else if (name === 'Old Cut Cushion' || name === 'Antique-Style Cushion') {
    json.shapes = ['Old Cut Cushion']
    json.symmetry_to = "Fair"
    json.color_to = "K"
  } else if (name === 'Princess') {
    json.shapes = ['Princess']
    json.symmetry_to = "Good"
    json.color_to = "J"
  } else if (name === 'Marquise') {
    json.shapes = ['Marquise']
    json.symmetry_to = "Good"
    json.color_to = "J"
  } else {
    return null
  }
  return json
}

function generateSliders(diamondShape, pageload) {
  let sliderParams = requestParameterByDiamondName(diamondShape)
  if (sliderParams && sliderParams.color_from && sliderParams.color_to) {
    var colors = ['0', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M']
    var colorStartIndex = colors.indexOf(sliderParams.color_from)
    var colorEndIndex = colors.indexOf(sliderParams.color_to)
    var slicedColors = colors.slice(colorStartIndex, colorEndIndex + 1)
    var colorLabelLis = ''
    slicedColors.map(function (item, index) {
      colorLabelLis += `<li>${item}</li>`
    })
    $("#colorSliderLabels").html(colorLabelLis)
    $("#colorSliderLabels").addClass(`color__slider__labels__${slicedColors.length}`)

    if (colorStartIndex && colorEndIndex) {
      var colorSliderOption = {
        start: [1, 12],
        step: 1,
        range: {
          'min': [colorStartIndex],
          'max': [colorEndIndex]
        },
        format: moneyFormat,
        connect: true
      }
      // Set Color Slider Values from localstorage
      let data = getBodyParams()
      if (data && Array.isArray(data.shapes) && data.shapes.some(shape => defaultDiamondShape.includes(shape)) && data.color_from && data.color_to) {
        let colorStartIndex = colors.indexOf(data.color_from)
        let colorEndIndex = colors.indexOf(data.color_to)
        colorSliderOption.start = [colorStartIndex, colorEndIndex]
      }
      if (pageload === '') {
        if (colorSlider && colorSlider.noUiSlider) {
          colorSlider.noUiSlider.destroy();
        }
        noUiSlider.create(colorSlider, colorSliderOption);
      } else {
        new Promise(function (res, rej) {
          colorSlider.noUiSlider.updateOptions(colorSliderOption)
          res()
        })
      }
      colorSlider.noUiSlider.on('slide', function (values, handle) {
        callRapnetFeed = true;
      })

      // Set visual min and max values and also update value hidden form inputs removing end by set
      colorSlider.noUiSlider.on('set', function (values, handle) {
        bodyToSend.color_from = getColorFromNumber(values[0])
        bodyToSend.color_to = getColorFromNumber(values[1])
        bodyToSend.page_number = 1
        setBodyParams()
        var timer;
        var isSomethingTrue;
        $("#colorSlider").on("keyup click", function () {
          clearTimeout(timer);
          timer = setTimeout(function () {
            if (localStorage.getItem("runOneTime") === null) {
              getRapnetFeed(true);
              localStorage.setItem("runOneTime", 'true');
            } else {
              isSomethingTrue = false;
            }
          }, 500);
        });
        setTimeout(function () {
          localStorage.removeItem("runOneTime");
        }, 1000);
        if (!isSomethingTrue) {
          $("#colorSlider").click();
        };
      });
    }
  }

  /* Seting up slider for Fluorescence */
  if (sliderParams && sliderParams.fluorescence_intensities) {
    var slicedFluorescence = sliderParams.fluorescence_intensities
    let fluorescenceStartIndex = 1
    let fluorescenceEndIndex = 4
    var fluorescenceLabelLis = ''
    slicedFluorescence.map(function (item, index) {
      fluorescenceLabelLis += `<li>${item}</li>`
    })
    $("#fluorescenceSliderLabels").html(fluorescenceLabelLis)
    $("#fluorescenceSliderLabels").addClass(`fluorescence__slider__labels__${slicedFluorescence.length}`)

    if (fluorescenceStartIndex && fluorescenceEndIndex) {
      var fluorescenceSliderOption = {
        start: [1, 4],
        step: 1,
        range: {
          'min': [fluorescenceStartIndex],
          'max': [fluorescenceEndIndex]
        },
        format: moneyFormat,
        connect: true
      }

      // Set Fluorescence Slider Values from localstorage
      let data = getBodyParams()
      if (data && Array.isArray(data.shapes) && data.shapes.some(shape => defaultDiamondShape.includes(shape)) && data.fluor_intensity_min && data.fluor_intensity_max) {
        let fluorescenceStartIndex = data.fluor_intensity_min
        let fluorescenceEndIndex = data.fluor_intensity_max
        fluorescenceSliderOption.start = [fluorescenceStartIndex, fluorescenceEndIndex]
      }

      if (pageload === '') {
        if (fluorescenceSlider && fluorescenceSlider.noUiSlider) {
          fluorescenceSlider.noUiSlider.destroy();
        }
        noUiSlider.create(fluorescenceSlider, fluorescenceSliderOption);
      } else {
        new Promise(function (res, rej) {
          fluorescenceSlider.noUiSlider.updateOptions(fluorescenceSliderOption)
          res()
        })
      }
      fluorescenceSlider.noUiSlider.on('slide', function (values, handle) {
        callRapnetFeed = true;
      })

      // Set visual min and max values and also update value hidden form inputs removing end by set
      fluorescenceSlider.noUiSlider.on('set', function (values, handle) {
        var grabFluorescenceData = getFluorescenceFromArray(values, slicedFluorescence)
        bodyToSend.fluor_intensity = grabFluorescenceData && grabFluorescenceData.length ? grabFluorescenceData : ""
        bodyToSend.fluor_intensity_min = grabFluorescenceData && grabFluorescenceData.length ? values[0] : ""
        bodyToSend.fluor_intensity_max = grabFluorescenceData && grabFluorescenceData.length ? values[1] : ""
        bodyToSend.page_number = 1
        setBodyParams()
        var timer;
        var isSomethingTrue;
        $("#fluorescenceSlider").on("keyup click", function () {
          clearTimeout(timer);
          timer = setTimeout(function () {
            if (localStorage.getItem("runOneTime") === null) {
              getRapnetFeed(true);
              localStorage.setItem("runOneTime", 'true');
            } else {
              isSomethingTrue = false;
            }
          }, 500);
        });
        setTimeout(function () {
          localStorage.removeItem("runOneTime");
        }, 1000);
        if (!isSomethingTrue) {
          $("#fluorescenceSlider").click();
        };
      });
    }
  }

  if (sliderParams && sliderParams.clarity_from && sliderParams.clarity_to) {
    var clearity = ["0", "IF", "VVS1", "VVS2", "VS1", "VS2", "SI1", "SI2", "SI3", "I1", "I2", "I3"]
    var clearityStartIndex = clearity.indexOf(sliderParams.clarity_from)
    var clearityEndIndex = clearity.indexOf(sliderParams.clarity_to)
    var slicedClearity = clearity.slice(clearityStartIndex, clearityEndIndex + 1)
    var colorLabelLis = ''
    slicedClearity.map(function (item, index) {
      colorLabelLis += `<li>${item}</li>`
    })
    $('#clearitySliderLabels').removeClass(function (index, className) {
      return (className.match(/clearity_items_\d+/g) || []).join(' ');
    });
    let clearitySliderClassName = `clearity_items_${slicedClearity.length}`
    $("#clearitySliderLabels").html(colorLabelLis)
    $("#clearitySliderLabels").addClass(clearitySliderClassName)

    if (clearityStartIndex && clearityEndIndex) {
      var claritySliderOption = {
        start: [1, 8],
        step: 1,
        range: {
          'min': [clearityStartIndex],
          'max': [clearityEndIndex]
        },
        format: moneyFormat,
        connect: true
      }

      // Set Clearity Slider Values from localstorage
      let data = getBodyParams()
      if (data && Array.isArray(data.shapes) && data.shapes.some(shape => defaultDiamondShape.includes(shape)) && data.clarity_from && data.clarity_to) {
        let clearityStartIndex = clearity.indexOf(data.clarity_from)
        let clearityEndIndex = clearity.indexOf(data.clarity_to)
        claritySliderOption.start = [clearityStartIndex, clearityEndIndex]
      }
      if (pageload === '') {
        if (claritySlider && claritySlider.noUiSlider) {
          claritySlider.noUiSlider.destroy();
        }
        noUiSlider.create(claritySlider, claritySliderOption);
      } else {
        new Promise(function (res, rej) {
          claritySlider.noUiSlider.updateOptions(claritySliderOption)
          res()
        })
      }
      claritySlider.noUiSlider.on('slide', function (values, handle) {
        callRapnetFeed = true;
      });

      claritySlider.noUiSlider.on('set', function (values, handle) {
        bodyToSend.clarity_from = getClarityFromNumber(values[0])
        bodyToSend.clarity_to = getClarityFromNumber(values[1])
        bodyToSend.page_number = 1
        setBodyParams()
        var timer;
        var isSomethingTrue;
        $("#claritySlider").on("keyup click", function () {
          clearTimeout(timer);
          timer = setTimeout(function () {
            if (localStorage.getItem("runOneTime") === null) {
              getRapnetFeed(true);
              localStorage.setItem("runOneTime", 'true');
            } else {
              isSomethingTrue = false;
            }
          }, 500);
        });
        setTimeout(function () {
          localStorage.removeItem("runOneTime");
        }, 1000);
        if (!isSomethingTrue) {
          $("#claritySlider").click();
        }
      });
    }
  }

  getDiamondMaxMinInfo(diamondShape, (error, data) => {
    if (!error) {
      // Setting the slider with max and min prices
      if (data) {
        let getDiamondLabType = getParameterByName('diamondLabType')
        // var minPrice = 2000 ****Before change****
        var minPrice = minNaturalDiamondPrice 
        var maxPrice = maxNaturalDiamondPrice
        if (getDiamondLabType && getDiamondLabType === 'lab') {
          // minPrice = 1000  ****Before change****
          minPrice = minLabGrownDiamondPrice
          maxPrice = maxLabGrownDiamondPrice
        }
        // Creating a slider
          $(".range__slider-item.rangePrice").removeClass('hide')
          $("#filter_show_hide").removeClass("pTop")
          var objPrice = {
            start: [minPrice, maxPrice],
            step: 250,
            tooltips: false,
            range: {
              'min': [minPrice],
              'max': [maxPrice]
            },
            format: moneyFormat,
            connect: true
          }

          // Set Clearity Slider Values from localstorage
          let gbp = getBodyParams()
        
          if (gbp && Array.isArray(gbp.shapes) && gbp.shapes.some(shape => defaultDiamondShape.includes(shape)) && gbp.price_total_from && gbp.price_total_to) {
            objPrice.start = [gbp.price_total_from, gbp.price_total_to]
          }
          if (pageload === '') {
            if(rangeSlider && rangeSlider.noUiSlider){
              rangeSlider.noUiSlider.destroy();
            }
            noUiSlider.create(rangeSlider, objPrice);
          } else {
            new Promise(function(res, rej) {
              rangeSlider.noUiSlider.updateOptions(objPrice)
              res()
            })
          }
          rangeSlider.noUiSlider.on('slide', function(values, handle) {
            callRapnetFeed = true;
          });

          /* Appending Custom Input as Tooltip for Price */
          var tooltipPrice = [
            $('<input type="text" class="custom-tooltip-price" />').appendTo(rangeSlider),
            $('<input type="text" class="custom-tooltip-price" />').appendTo(rangeSlider)
          ];

          rangeSlider.noUiSlider.on('update', function (values, handle) {
            tooltipPrice[handle].val('$' + removeDoller(values[handle]));
            if (handle === 0) {
              /* Left corner */
              tooltipPrice[handle].css({
                position: 'absolute',
                top: '20px',
                left: '0px'
              });
            } else {
              /* Right corner */
              tooltipPrice[handle].css({
                position: 'absolute',
                top: '20px',
                right: '0px'
              });
            }
          });

          // Block alphabet typing on page load for the custom tooltip input fields
          tooltipPrice.forEach(function (input) {
            input.on('keydown', function (e) {
              // Allow backspace, delete, tab, escape, and enter
              if ($.inArray(e.keyCode, [46, 8, 9, 27, 13]) !== -1 ||
                 // Allow Ctrl+A, Ctrl+C, Ctrl+V, Ctrl+X, and arrow keys
                (e.keyCode === 65 && (e.ctrlKey === true || e.metaKey === true)) || 
                (e.keyCode === 67 && (e.ctrlKey === true || e.metaKey === true)) || 
                (e.keyCode === 86 && (e.ctrlKey === true || e.metaKey === true)) || 
                (e.keyCode === 88 && (e.ctrlKey === true || e.metaKey === true)) || 
                (e.keyCode >= 35 && e.keyCode <= 39)) {
                  return;  // Let it happen, don't do anything
              }
              // Block alphabets and non-numeric keys
              if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105)) {
                e.preventDefault();  // Block non-numeric keypresses
              }
            });
          });

          // Listen for 'input' events with debounce and 'change' or 'blur' events to apply the final value
          let debounceTimer;
          tooltipPrice.forEach(function (input, handle) {
            // Trigger when user stops typing
            input.on('input', function () {
              clearTimeout(debounceTimer); // Clear any previous debounce timer
              debounceTimer = setTimeout(() => {
                // Trigger only after user stops typing for 500ms
                var value = parseFloat($(this).val().replace(/[^0-9.-]+/g, "")); // Remove any non-numeric characters
                if (!isNaN(value)) {
                  // Ensure value is within the slider range
                  if (value < minPrice) value = minPrice;
                  if (value > maxPrice) value = maxPrice;
                  let currentValues = rangeSlider.noUiSlider.get(); // Get the current slider values
                  currentValues[handle] = value; // Update the specific handle with the new value from input
                  // Validate that min handle is always less than or equal to max handle
                  if (parseFloat(currentValues[0]) > parseFloat(currentValues[1])) {
                    if (handle === 0) currentValues[1] = currentValues[0]; // Adjust the right handle
                    else currentValues[0] = currentValues[1]; // Adjust the left handle
                  }
                  rangeSlider.noUiSlider.set(currentValues); // Set the updated values to the slider
                } else {
                  $(this).val(currentValues[handle]); // Reset the value if input is invalid
                }
              }, 500); // Debounce time set to 500ms
            });
          
            // Trigger slider update on 'change' or 'blur' when user stops interacting with the input field
            input.on('change blur', function () {
              clearTimeout(debounceTimer); // Clear any debounce since we're handling final change
              var value = parseFloat($(this).val().replace(/[^0-9.-]+/g, "")); // Remove any non-numeric characters
              if (!isNaN(value)) {
                // Ensure value is within the slider range
                if (value < minPrice) value = minPrice;
                if (value > maxPrice) value = maxPrice;
                let currentValues = rangeSlider.noUiSlider.get(); // Get the current slider values
                currentValues[handle] = value; // Update the specific handle with the new value from input
                // Validate that min handle is always less than or equal to max handle
                if (parseFloat(currentValues[0]) > parseFloat(currentValues[1])) {
                  if (handle === 0) currentValues[1] = currentValues[0]; // Adjust the right handle
                  else currentValues[0] = currentValues[1]; // Adjust the left handle
                }
                rangeSlider.noUiSlider.set(currentValues); // Set the updated values to the slider
              } else {
                $(this).val('$' + currentValues[handle]);  // Reset the value if input is invalid
              }
            });
          });

          // Set visual min and max values and also update value hidden form inputs
          rangeSlider.noUiSlider.on('set', function(values, handle) {
            let markupfromPrice = moneyFormat ? moneyFormat.from(values[0]) : values[0]
            let markuptoPrice = moneyFormat ? moneyFormat.from(values[1]) : values[1]
            bodyToSend.price_total_from = markupfromPrice
            bodyToSend.price_total_to = markuptoPrice
            bodyToSend.page_number = 1
            setBodyParams()
            var timer;
            var isSomethingTrue;
            $("#slider-range").on("keyup click",function(){
              clearTimeout(timer);
              timer = setTimeout(function() {
                if(localStorage.getItem("runOneTime") === null){
                  isSomethingTrue = true;
                  getRapnetFeed( true );  
                  localStorage.setItem("runOneTime", 'true');
                } else {
                  isSomethingTrue = false;
                }
              }, 800);
            });
            setTimeout(function(){
              localStorage.removeItem("runOneTime");
            }, 1000);
            if(!isSomethingTrue){
              $("#slider-range").click();
            }
          })
      } else {
        console.log("max and min price are not set")
      }

      // Setting the slider with max and min carat
      if (data) {
        let getDiamondLabType = getParameterByName('diamondLabType')
        if (data.minCarat === data.maxCarat) {
          $(".range__slider-item.rangeCarat").addClass('hide')
          $("#filter_show_hide").addClass("pTop")
        } else {
          $(".range__slider-item.rangeCarat").removeClass('hide')
          $("#filter_show_hide").removeClass("pTop")
          var caratMin = 1.00
          var caratMax = 7.10
          if (getDiamondLabType && getDiamondLabType === 'lab') {
            caratMin = 2.00
            caratMax = 5.00
          }
          var objCarat = {
            start: [caratMin, caratMax],
            step: 0.02,
            tooltips: false,
            range: {
              'min': caratMin,
              'max': caratMax
            },
            format: caratFormat,
            connect: true
          }

          // Set Clearity Slider Values from localstorage
          let gbp = getBodyParams()
          if (gbp && Array.isArray(gbp.shapes) && gbp.shapes.some(shape => defaultDiamondShape.includes(shape)) && gbp.size_from && gbp.size_to) {
            objCarat.start = [gbp.size_from, gbp.size_to]
          }
          if (pageload === '') {
            if (rangeSlider2 && rangeSlider2.noUiSlider) {
              rangeSlider2.noUiSlider.destroy();
            }
            noUiSlider.create(rangeSlider2, objCarat);
          } else {
            new Promise(function (res, rej) {
              rangeSlider2.noUiSlider.updateOptions(objCarat)
              res()
            })
          }
          rangeSlider2.noUiSlider.on('slide', function (values, handle) {
            callRapnetFeed = true;
          });

          /* Appending Custom Tooltip to the Feed for Carat Weight */
          var tooltipCarat = [
            $('<input type="text" class="custom-tooltip-carat"/>').appendTo(rangeSlider2),
            $('<input type="text" class="custom-tooltip-carat"/>').appendTo(rangeSlider2)
          ];
          rangeSlider2.noUiSlider.on('update', function (values, handle) {
            tooltipCarat[handle].val(values[handle]);
            if (handle === 0) {
              /* Left corner */
              tooltipCarat[handle].css({
                position: 'absolute',
                top: '20px',
                left: '0px'
              });
            } else {
              /* Right corner */
              tooltipCarat[handle].css({
                position: 'absolute',
                top: '20px',
                right: '0px'
              });
            }
          });

          // Block alphabet typing and allow decimal input on page load for the custom tooltip input fields
          tooltipCarat.forEach(function (input) {
            input.on('keydown', function (e) {
              // Allow backspace, delete, tab, escape, enter, and the decimal point (46, 190)
              if ($.inArray(e.keyCode, [46, 8, 9, 27, 13, 190]) !== -1 ||
                // Allow Ctrl+A, Ctrl+C, Ctrl+V, Ctrl+X, and arrow keys
                (e.keyCode === 65 && (e.ctrlKey === true || e.metaKey === true)) ||
                (e.keyCode === 67 && (e.ctrlKey === true || e.metaKey === true)) ||
                (e.keyCode === 86 && (e.ctrlKey === true || e.metaKey === true)) ||
                (e.keyCode === 88 && (e.ctrlKey === true || e.metaKey === true)) ||
                (e.keyCode >= 35 && e.keyCode <= 39)) {
                return;
              }
              // Ensure only one decimal point is allowed
              if (e.keyCode === 190 && $(this).val().indexOf('.') !== -1) {
                e.preventDefault();  // Prevent entering a second decimal point
              }
              // Block non-numeric keys except for the decimal point
              if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105) && e.keyCode !== 190 && e.keyCode !== 110) {
                e.preventDefault();  // Block non-numeric keypresses
              }
            });
          });

          // Listen for 'input' events with debounce and 'change' or 'blur' events to apply the final value
          let debounceTimer;
          tooltipCarat.forEach(function (input, handle) {
            // Trigger when user stops typing
            input.on('input', function () {
              clearTimeout(debounceTimer); // Clear any previous debounce timer
              debounceTimer = setTimeout(() => {
                // Trigger only after user stops typing for 500ms
                var value = parseFloat($(this).val().replace(/[^0-9.-]+/g, "")); // Remove any non-numeric characters except decimal point
                if (!isNaN(value)) {
                  // Ensure value is within the slider range
                  if (value < caratMin) value = caratMin;
                  if (value > caratMax) value = caratMax;
                  let currentValues = rangeSlider2.noUiSlider.get(); // Get the current slider values
                  currentValues[handle] = value; // Update the specific handle with the new value from input
                  // Validate that min handle is always less than or equal to max handle
                  if (parseFloat(currentValues[0]) > parseFloat(currentValues[1])) {
                    if (handle === 0) currentValues[1] = currentValues[0]; // Adjust the right handle
                    else currentValues[0] = currentValues[1]; // Adjust the left handle
                  }
                  rangeSlider2.noUiSlider.set(currentValues); // Set the updated values to the slider
                } else {
                  $(this).val(currentValues[handle]); // Reset the value if input is invalid
                }
              }, 900); // Debounce time set to 900ms
            });

            // Trigger slider update on 'change' or 'blur' when user stops interacting with the input field
            input.on('change blur', function () {
              clearTimeout(debounceTimer); // Clear any debounce since we're handling final change
              var value = parseFloat($(this).val().replace(/[^0-9.-]+/g, "")); // Remove any non-numeric characters except decimal point
              if (!isNaN(value)) {
                // Ensure value is within the slider range
                if (value < caratMin) value = caratMin;
                if (value > caratMax) value = caratMax;
                let currentValues = rangeSlider2.noUiSlider.get(); // Get the current slider values
                currentValues[handle] = value; // Update the specific handle with the new value from input
                // Validate that min handle is always less than or equal to max handle
                if (parseFloat(currentValues[0]) > parseFloat(currentValues[1])) {
                  if (handle === 0) currentValues[1] = currentValues[0]; // Adjust the right handle
                  else currentValues[0] = currentValues[1]; // Adjust the left handle
                }
                rangeSlider2.noUiSlider.set(currentValues); // Set the updated values to the slider
              } else {
                $(this).val(currentValues[handle]); // Reset the value if input is invalid
              }
            });
          });

          // Set visual min and max values and also update value hidden form inputs
          rangeSlider2.noUiSlider.on('set', function (values, handle) {
            bodyToSend.size_from = values[0]
            bodyToSend.size_to = values[1]
            bodyToSend.page_number = 1
            setBodyParams()
            var timer;
            var isSomethingTrue;
            $("#slider-range2").on("keyup click", function () {
              clearTimeout(timer);
              timer = setTimeout(function () {
                if (localStorage.getItem("runOneTime") === null) {
                  getRapnetFeed(true);
                  localStorage.setItem("runOneTime", 'true');
                } else {
                  isSomethingTrue = false;
                }
              }, 600);
            });
            setTimeout(function () {
              localStorage.removeItem("runOneTime");
            }, 1000);
            if (!isSomethingTrue) {
              $("#slider-range2").click();
            }
          })
        }
      } else {
        console.log("max and min size are not set")
      }

      // Setting the slider with max and min Ratio
      if (data) {
        var objRatio = {
          start: [0.95, 2.5],
          step: 0.02,
          tooltips: false,
          range: {
            'min': 0.95,
            'max': 2.5
          },
          format: caratFormat,
          connect: true
        }
        // Set Ratio Slider Values from localstorage
        let gbp = getBodyParams()
        if (gbp && Array.isArray(gbp.shapes) && gbp.shapes.some(shape => defaultDiamondShape.includes(shape)) && gbp.ratio_min && gbp.ratio_max) {
          objRatio.start = [gbp.ratio_min, gbp.ratio_max]
        }
        if (pageload === '') {
          noUiSlider.create(ratioSlider, objRatio);
        } else {
          new Promise(function (res, rej) {
            ratioSlider.noUiSlider.updateOptions(objRatio)
            res()
          })
        }
        ratioSlider.noUiSlider.on('slide', function (values, handle) {
          callRapnetFeed = true;
        });
        /* Appending Custom Tooltip to the Feed for Carat Weight */
        var tooltipRatio = [
          $('<div class="custom-tooltip-ratio"></div>').appendTo(ratioSlider),
          $('<div class="custom-tooltip-ratio"></div>').appendTo(ratioSlider)
        ];
        ratioSlider.noUiSlider.on('update', function (values, handle) {
          tooltipRatio[handle].text(values[handle]);
          if (handle === 0) {
            /* Left corner */
            tooltipRatio[handle].css({
              position: 'absolute',
              top: '20px',
              left: '0px'
            });
          } else {
            /* Right corner */
            tooltipRatio[handle].css({
              position: 'absolute',
              top: '20px',
              right: '0px'
            });
          }
        });

        // Set visual min and max values and also update value hidden form inputs
        ratioSlider.noUiSlider.on('set', function (values, handle) {
          bodyToSend.ratio_min = parseFloat(values[0])
          bodyToSend.ratio_max = parseFloat(values[1])
          bodyToSend.page_number = 1
          setBodyParams()
          var timer;
          var isSomethingTrue;
          $("#ratio-slider-range").on("keyup click", function () {
            clearTimeout(timer);
            timer = setTimeout(function () {
              if (localStorage.getItem("runOneTime") === null) {
                getRapnetFeed(true);
                localStorage.setItem("runOneTime", 'true');
              } else {
                isSomethingTrue = false;
              }
            }, 500);
          });
          setTimeout(function () {
            localStorage.removeItem("runOneTime");
          }, 1000);
          if (!isSomethingTrue) {
            $("#ratio-slider-range").click();
          }
        })
      } else {
        console.log("max and min ratio are not set")
      }
    }
  })
}

function sortBy(key, e) {
  var sortKey = 'Desc'
  var lastClicked = sortOrder[key]
  if( lastClicked == 'Desc' ) {
    sortOrder[key] = 'Asc'
    sortKey = 'Asc'
  } else {
    sortOrder[key] = 'Desc'
  }
  if(key === "price") {
    bodyToSend.sort_by = "Price"
  } else if(key === "carat") {
    bodyToSend.sort_by = "Size"
  } else {
    bodyToSend.sort_by = key
  }
  bodyToSend.sort_direction = sortKey
  setBodyParams()
  getRapnetFeed(removeDid = true)
}

function paginationFunction(e, indexParam) {
  document.getElementById("select-diamond-popup").scrollIntoView();
  var index = $(e).attr("data-index") ? $(e).attr("data-index") : indexParam
  bodyToSend.page_number = index
  let newPageUrl = getUrlWithoutDid()
  let str4 = updateQueryStringParameter(newPageUrl, 'page', index)
  history.pushState({}, "", str4)
  window.location.reload()
  getRapnetFeed()
}

function generateDiamondHtml(body, defaultDiamondShape, sold_certs_id, cb) {
  let index = 0;
  let accordionItems = ''
  let selectedCertNu = null
  let diamondLabType = getParameterByName('diamondLabType')
  // Diamond Lab Type
  let viewCertificateLabel = ""
  if( diamondLabType && diamondLabType == "natural" ) {
    viewCertificateLabel = "View GIA Certificate"
  } else {
    viewCertificateLabel = "View Certificate"
  }
  
  if( body.hasOwnProperty('diamonds') && body.diamonds.length > 0 ) {
    // Getting the selected raw diamond
    var _raw_diamond_info    = localStorage.getItem( '_raw_diamond_info')
    var _diamonds_to_compare = getComparedDiamonds()
    if (_raw_diamond_info) {
      let rawDiamondInfo = JSON.parse(_raw_diamond_info)
      selectedCertNu = rawDiamondInfo.certNum
    }
    var fetchNext = function() {
      if(index < body.diamonds.length) {                        
        let diamond = body.diamonds[index];
        // For Round shape diamond always show cut Excellent
        if( diamond.shape == "Round") {
        } else {
          diamond.cut = "Excellent"
        }
        let image = '';
        let source = diamond.source;
        let uniqueIdentifier = diamond.cert_num;
        let uniqueId = ''+diamond.cert_num+'';
        let certificateUrl = `https://www.gia.edu/report-check?reportno=${diamond.cert_num}`
        let markedUpPrice = diamond.marked_up_price

        if(diamond.hasOwnProperty("source") && diamond.source !== 'Rapnet') {
          source = diamond.source
          uniqueIdentifier = diamond.cert_num
          certificateUrl = `https://www.gia.edu/report-check?reportno=${diamond.cert_num}`
        }
        if (source === "FN" || source === "GR" || source === "SL" || source === "MD") {
          certificateUrl = diamond.certificate_image
        }
        
        allPrice.push(markedUpPrice)
        allCarats.push(diamond.size)
        let mediaHtml = '<div class="loader__section"><div class="loader loader-20"><div class="css-diamond"></div></div></div>';
        var amt = `${diamond.currency_symbol}${commafy(markedUpPrice)}`;
        var meas = `${diamond.meas_length} x ${diamond.meas_width} x ${diamond.meas_depth}`
        var diamondCut = `${diamond.shape === "Round" ? diamond.cut : 'Excellent'}`;
        var objs = `${diamond.size}ct_${diamond.color}_${diamond.clarity}_${diamondCut}_${amt}_${meas}`;
        var selectDiamond = `${amt} - ${diamond.size.toFixed(2)}ct, ${diamond.color}, ${diamond.clarity}`;
        let defaultPanel = `<div class="panel__inner-left" id="panel__inner${uniqueIdentifier}">${mediaHtml}</div>`
        var dimenstion = `${diamond.meas_length} x ${diamond.meas_width} x ${diamond.meas_depth}`
        if (diamond.dimensions && diamond.dimensions !== '') {
          dimenstion = diamond.dimensions
        }
        
        let isSelectedClass = selectedCertNu == diamond.cert_num ? true : false
        let certificateIcon = `<img width="65px" src="https://rc-diamond-images.s3.us-east-2.amazonaws.com/Gemological.png" alt="GIA Certificate" />`
        if( diamondLabType && diamondLabType == "lab" ) {
          certificateIcon = "<span class='pink_cert_link'>View <span class='view-certificate-text'>Certificate</span></span>"
          /* Show Custom IGI Certificate of Aarush Vendor */
          if(diamond.source === 'AA'){
            var encodedRtn = btoa(diamond.cert_num); /* Encoding Cert Number */
            certificateUrl = `/pages/igi-certificate?rtn=${encodedRtn}`
          }
        }
        var priceSortIcon = `<svg class="sort-arrow" width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <line x1="13.2929" y1="7" x2="7" y2="0.707107" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
                              <line x1="7" y1="0.707107" x2="0.707107" y2="7" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>`
        /* Removing Sold out Diamonds to Show on the UI (Messing up the grid with wrong BG Color) */
        var dontShowSoldOutOnUI = true;
        var diamondTypegrab = diamond.lg

        if( sold_certs_id.indexOf(uniqueIdentifier) !== -1 && dontShowSoldOutOnUI !== true) {
          let btnBox = `<button disabled="disabled" type="button" class="btn-default select__button">SOLD OUT</button>`;
          accordionItems += `<div class="table__accordion-item ${isSelectedClass ? "table__accordion-item-active" : ''} hide" id="${uniqueIdentifier}">
            <div data-aid="accordion${diamond.cert_num}" data-cert_num="${diamond.cert_num}" videourl="${diamond.video}" data-rapnet_account_id="${diamond.rapnet_account_id}" data-stockNumber="${diamond.stock_num}" data-shape="${diamond.shape}" data-diamondId="${diamond.diamond_id}" uniqueid="${uniqueIdentifier}" class="accordion">
              <ul class="emerald__accordion-list">
                <li>${diamond.size.toFixed(2)}ct</li>
                <li>${diamond.color}</li>
                <li>${diamond.clarity}</li>
                <li>${diamond.shape == "Round" ? diamond.cut : 'Excellent'}</li>
                <li><a target="_blank" href="${certificateUrl}">${certificateIcon}</a></li>
                <li class="sold__out">Sold Out ${priceSortIcon}</li>
                <li class="accordion__details--title">
				          <span class="view-comapre-wrap">
                    <a href="javascript:void(0)" tabindex="0">
                  	  <span class="btn-view-details">${priceSortIcon}</span>
                    </a>
                    <span class="compare-checkbox" data-title-tooltip="Add to Compare">
                      <label class="custom-checkbox checkbox-only">
                        <input
                          class="custom-checkbox-input compare_diamond_selector"
                          name="compare_diamond_selector[]"
                          onclick="compareThisDiamond(this)"
                          data-cert_num="${diamond.cert_num}"
                          ${ _diamonds_to_compare.indexOf(diamond.cert_num) !== -1 ? "checked" : "" }
                          type="checkbox"
                        />
                        <span class="custom-checkbox-checkmark"></span>
                      </label>
                    </span>
                  </span>
                </li>
              </ul>
            </div>
            <div class="panel" style="display:none">
              <div class="panel__inner">
                ${defaultPanel}
                <span class="caption">*actual diamond</span>
                <div class="panel__inner-right">
                   <ul class="panel__inner-list">
                      <li style="display:none"><span>DEPTH %:</span>${diamond.depth_percent}</li>
                      <li style="display:none"><span>TABLE %:</span>${diamond.table_percent}%</li>
					            <li><span>CERTIFICATE:</span><a target="_blank" href="${certificateUrl}">${viewCertificateLabel}</a>
                        <div class="sharecopywrapper">
                          <button
                            type="button"
                            onclick="showHide()"
                            data-shareId="${diamond.cert_num}"
                            data-diamond-internal-reference-id="${diamond._id}"
                            data-uniqueidentifier="${uniqueIdentifier}"
                            data-source="${source}"
                            data-shape="${diamond.shape}"
                            data-diamondId="${diamond.cert_num}"
                            data-objs="${objs}"
                            data-selectDiamond="${selectDiamond}"
                            data-isLgTrue="${diamondTypegrab}"
                            class="btn-default buttonsharediamond select__button ${uniqueId} share__diamond_url
                            select${uniqueIdentifier} select__button "
                          ><svg xmlns="http://www.w3.org/2000/svg" width="21" height="18" viewBox="0 0 21 18" fill="none"><path d="M20.6026 6.06497C20.8678 6.31683 21 6.62763 21 7.00013C21 7.35702 20.8678 7.66933 20.6026 7.93404L15.0077 13.5639C14.6196 13.9566 14.2846 14.0895 14.0033 13.9681C13.7222 13.8528 13.5824 13.5226 13.5824 12.9829V9.22206C11.5937 9.24019 9.84025 9.45503 8.32907 9.86834C6.8179 10.2821 5.54222 10.8403 4.50103 11.5462C3.45907 12.2532 2.64354 13.0854 2.05041 14.0427C1.45853 15.0005 1.08628 16.0279 0.93466 17.1303C0.904185 17.3821 0.761882 17.5068 0.511028 17.5068H0.487857C0.240025 17.5068 0.0972187 17.3821 0.0669952 17.1303C0.0209045 16.7452 0 16.3588 0 15.9677C0 14.383 0.269492 12.8856 0.81427 11.4865C1.35728 10.0822 2.1849 8.85887 3.29864 7.80811C4.41212 6.76263 5.82078 5.92997 7.52765 5.31669C9.23175 4.69761 11.2517 4.38152 13.5824 4.36843V1.0305C13.5824 0.480936 13.7197 0.151753 13.9942 0.0394225C14.266 -0.0761822 14.6055 0.0630974 15.0077 0.44895L20.6026 6.06497Z" fill="black"/></svg></button>
                        </div>
                      </li>
                      <li><span>MEASUREMENTS (MM):</span>${dimenstion}</li>
                      <li><span>POLISH:</span>${diamond.polish}&nbsp;${polishToolTip}&nbsp;</li>
                      <li><span>SYMMETRY:</span>${diamond.symmetry}&nbsp;${symmetryToolTip}&nbsp;</li>
                      <li><span>FLUORESCENCE:</span>${diamond.fluor_intensity}&nbsp;${flToolTip}&nbsp;</li>
                   </ul>
                   ${btnBox}
                 </div>
              </div>
            </div>
          </div>`;
        } else {
          let btnBox = `
			      <button
              type="button"
              onclick="saveDiamond(this)"
              data-diamond-internal-reference-id="${diamond._id}"
              data-uniqueidentifier="${uniqueIdentifier}"
              data-source="${source}"
              data-shape="${diamond.shape}"
              data-diamondId="${diamond.diamond_id}"
              data-cert_num="${diamond.cert_num}"
              data-objs="${objs}"
              data-selectDiamond="${selectDiamond}"
              data-isLgTrue="${diamondTypegrab}"
              data-total-sales-price="${diamond.total_sales_price}"
              data-diamond-markup-price="${markedUpPrice}"
              class="btn-default add-ring-btn select__button ${uniqueId}
              select${uniqueIdentifier} select__button"
            >${isSelectedClass ? "REVIEW YOUR DESIGN" : "SELECT THIS DIAMOND"}</button>
			      <div class="align-buttons">
              <button type="button" onclick="GorgiasChat.open()"  class="vow-btn-dark-outline vow-black-border-white-bg custom-compare-button">
                 chat with a specialist
              </button>
              <button
                type="button"
                onclick="showHide()"
                data-shareId="${diamond.cert_num}"
                data-uniqueidentifier="${uniqueIdentifier}"
                data-source="${source}"
                data-shape="${diamond.shape}"
                data-diamondId="${diamond.cert_num}"
                data-objs="${objs}"
                data-selectDiamond="${selectDiamond}"
                data-isLgTrue="${diamondTypegrab}"
                class="btn-default vow-black-border-white-bg vow-btn-dark-outline buttonsharediamond ${uniqueId} share__diamond_url
                select${uniqueIdentifier} select__button">
                <img src="https://cdn.shopify.com/s/files/1/1359/2701/files/send.svg?v=1720080010" /> 
                Share Diamond</button>
            </div>
            <button type="button"
              data-uniqueidentifier="${uniqueIdentifier}"
              onclick="deSelectDiamond(this)"
              class="btn-default deselect${uniqueIdentifier} bespoke_remove_btn select__button ${!isSelectedClass ? 'hide' : ''}"
            >Remove Diamond</button>`
            accordionItems += `<div class="table__accordion-item ${isSelectedClass ? "table__accordion-item-active" : ''} withoutsoldout" id="${uniqueIdentifier}">
			      <div data-aid="accordion${diamond.cert_num}" data-cert_num="${diamond.cert_num}" videourl="${diamond.video}" data-rapnet_account_id="${diamond.rapnet_account_id}" data-stockNumber="${diamond.stock_num}" data-shape="${diamond.shape}" data-diamondId="${diamond.diamond_id}" uniqueid="${uniqueIdentifier}" class="accordion accordion-edit">
              <ul class="emerald__accordion-list">
                <li ${diamond.shape == 'Oval' ? " class='adjustSpace'" : ""}><span class='adjust-icons'>${getIcons(diamond.shape)}</span>${diamond.shape}</li>
                <li>${diamond.size.toFixed(2)}ct</li>
                <li>${diamond.color}</li>
                <li>${diamond.clarity}</li>
                <li>${diamond.shape == "Round" ? diamond.cut : 'Excellent'}</li>
                <li> <a target="_blank" href="${certificateUrl}">${certificateIcon}</a></li>
                <li class="price__tag">${amt} ${priceSortIcon}</li>
                <li class="accordion__details--title accordion__details--title-edit">
                  <span class="view-comapre-wrap view-comapare-wrap-edit">
                      <button class="natural-diamond-flow-btn-cst" tabindex="0" aria-label="view Details">
                        <span class="btn-view-details">${priceSortIcon}</span>
                      </button>
                  </span>
                </li>
                <li>
                  <span class="view-comapre-wrap">
                    <span class="compare-checkbox" data-title-tooltip="Add to Compare">
                      <label class="custom-checkbox checkbox-only">
                        <input
                          type="checkbox"
                          role="checkbox"
                          class="custom-checkbox-input compare_diamond_selector"
                          name="compare_diamond_selector[]"
                          onclick="compareThisDiamond(this)"
                          data-cert_num="${diamond.cert_num}"
                          ${ _diamonds_to_compare.indexOf(diamond.cert_num) !== -1 ? "checked" : "" }
                          aria-checked="${_diamonds_to_compare.indexOf(diamond.cert_num) !== -1 ? 'true' : 'false'}"/>
                        <span class="custom-checkbox-checkmark"></span>
                      </label>
                    </span>
                  </span>
                </li>
              </ul>
            </div>
            <div class="panel" style="display:none">
              <div class="panel__inner">
                ${defaultPanel}
                <span class="caption">*actual diamond</span>
                <div class="panel__inner-right">
                   <ul class="panel__inner-list">
                      <li style="display:none"><span>DEPTH %:</span>${diamond.depth_percent}</li>
                      <li style="display:none"><span>TABLE %:</span>${diamond.table_percent}%</li>
					            <li><span>CERTIFICATE:</span><a target="_blank" href="${certificateUrl}">${viewCertificateLabel}</a></li>
                      <li><span>MEASUREMENTS (MM):</span>${dimenstion}</li>
                      <li><span>POLISH:</span>${diamond.polish}&nbsp;${polishToolTip}&nbsp;</li>
                      <li><span>SYMMETRY:</span>${diamond.symmetry}&nbsp;${symmetryToolTip}&nbsp;</li>
                      <li><span>FLUORESCENCE:</span>${diamond.fluor_intensity}&nbsp;${flToolTip}&nbsp;</li>
                   </ul>
                   ${btnBox}
                 </div>
                 
                  <div class="new-compare-checkbox">
                      <button type="button" onclick="triggerCheckBox(this)" data-cert_num="${diamond.cert_num}" class="vow-btn-dark-outline vow-black-border-white-bg ">
                        ${ _diamonds_to_compare.indexOf(diamond.cert_num) !== -1 ? "Added To Compare" : "Add To Compare" }
                      </button>
                      <span class="accordion__details--title">
                          <span class="view-comapre-wrap">
                              <span class="compare-checkbox" >
                                  <label class="custom-checkbox checkbox-only">
                                      <input class="custom-checkbox-input compare_diamond_selector" name="compare_diamond_selector[]"
                                          onclick="compareThisDiamond(this)" data-cert_num="${diamond.cert_num}" ${
                                          _diamonds_to_compare.indexOf(diamond.cert_num) !==-1 ? "checked" : "" } type="checkbox" />
                                      <span class="custom-checkbox-checkmark"></span>
                                  </label>
                              </span>
                          </span>
                      </span>
                  </div>
                  <button class="dismiss-popup"><img src="https://cdn.shopify.com/s/files/1/0414/0240/0929/files/ic-popup-close.svg?v=1719825464" /></button>
              </div>
            </div>
          </div>`;
        }
        index++;
        fetchNext()
      } else {
        cb(null, {data:body, html:accordionItems})
      }
    }
    fetchNext()
  } else {
    var grabDiamonds = defaultDiamondShape.join(', ');
    accordionItems = '<div class="table__accordion-item"><div class="accordion noDiamond">There are currently no '+grabDiamonds+' diamonds available in your selected criteria. Try adjusting your filters or check back later for more options!</div></div>'
    body = {
      search_results: {
        diamonds_returned: 0,
        total_diamonds_found: 0
      },
      diamonds: []
    }
    cb(null, {data:body, html:accordionItems})
    let currentUrl = window.location.href;
    var getPageInfo = getParameterByName('page')
    let redirectUrl = currentUrl.replace(`&page=${getPageInfo}`,'')
    if(localStorage.getItem("setUrl") === null){
      window.location.href = redirectUrl
      localStorage.setItem("setUrl","True")
    }
  }
}

setTimeout(function(){  
  localStorage.removeItem("setUrl");
}, 10000);  

function getRapnetFeed(removeDid = false) {
  var _raw_diamond_info = localStorage.getItem('_raw_diamond_info');
  var rawDiamondInfo = JSON.parse(_raw_diamond_info)
  let defaultDiamondShape = getDiamond()
  let apiUrl = diamondsInfoApiUrl
  // If removeDid is true then remove parameter from URL so that no popup will come
  let diamondIdToShowOnTop = false
  if (removeDid == true) {
    history.pushState({}, "", getUrlWithoutDid())
  } else {
    diamondIdToShowOnTop = getParameterByName("did")
  }
  if (!defaultDiamondShape) {
    return;
  } else {
    // Removing the HTML & Pagination
    $(".siteLoader").show()
    // Setting the blank HTML
    document.getElementById("pagination").innerHTML = ""
    let bodyParams = getBodyParams()
    // Removing the diamond if from request parameter so that clicked diamond will not come at top position
    if (removeDid == true) {
      delete bodyParams.diamondIdAtFirstPosition
    }
    if (bodyParams && Array.isArray(bodyParams.shapes) && bodyParams.shapes.some(shape => defaultDiamondShape.includes(shape))) {
      bodyToSend = bodyParams
    } else {
      bodyToSend.shapes = defaultDiamondShape
    }
    if (diamondIdToShowOnTop) {
      bodyToSend.diamondIdAtFirstPosition = diamondIdToShowOnTop
    }
    if (getParameterByName('diamondLabType') == "lab") {
      bodyToSend.lg = true
    } else {
      bodyToSend.lg = false
    }

    callApiAsPerDiamond(defaultDiamondShape, bodyToSend)
    .then((body) => {
      return new Promise(function(resolve, reject) {
        // Get the certificates of sold diamonds
        commonApiCalls({
          apiUrl: storePrivateApiUrl+`/userorders`,
          method:'GET'
        }, (soldD) => {
          generateDiamondHtml(body, defaultDiamondShape, soldD.sold_certs_id, (error, data) => {
            if(!error) {
              resolve(data)
            }
          })
        })
      })
    })
    .then(function(data) {
      let searchResult = data.data.search_results
      // Showing pagination if records are greater
      if(searchResult && bodyToSend && searchResult.total_diamonds_found > bodyToSend.page_size) {
        var totalDiamonds = searchResult.total_diamonds_found
        var recordsPerPage = bodyToSend.page_size
        var requiredPages = Math.ceil(totalDiamonds/recordsPerPage)
        var pagination = '';
        if (totalDiamonds > 100) {
          for (var i = 1; i <= requiredPages; i++) {
 			      if(bodyToSend.page_number == i) {
              pagination += `<li  role="link" class="paginationItem active" tabindex="0" data-index="${i}" onkeypress="paginationFunction(this)" aria-label="page ${i}" aria-current="page" onclick="paginationFunction(this)">${i}</li>`
            } else {
              pagination += `<li role="link" class="paginationItem" tabindex="0" data-index="${i}" onkeypress="paginationFunction(this)"aria-label="page ${i}" onclick="paginationFunction(this)">${i}</li>`
            }
          }
        }
        document.getElementById("pagination").innerHTML = pagination
      } else if (searchResult.total_diamonds_found < 100) {
        document.getElementById("pagination").innerHTML = '';
      }
      return data;
    })
    .then(function(data) {
      const arrowUp = `<svg class="sort-arrow" width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <line x1="13.2929" y1="7" x2="7" y2="0.707107" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
                          <line x1="7" y1="0.707107" x2="0.707107" y2="7" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>`;
      var arrowDown = `<svg class="sort-arrow" width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <line x1="0.707107" y1="1" x2="7" y2="7.29289" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
                          <line x1="7" y1="7.29289" x2="13.2929" y2="1" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
                       </svg>`
      var caratSymbol = priceSymbol = claritySymbol = colorSymbol = cutSymbol = shapesSymbol = arrowUp
      if(bodyToSend.sort_by == "Price" && bodyToSend.sort_direction == "Desc") {
        priceSymbol = arrowDown
        priceOrder = "d"
      } else if(bodyToSend.sort_by == "Size" && bodyToSend.sort_direction == "Desc") {
        caratSymbol = arrowDown
        caratOrder = "d"
      } else if(bodyToSend.sort_by == "clarity" && bodyToSend.sort_direction == "Desc") {
        claritySymbol = arrowDown
        clarityOrder = "d"
      } else if(bodyToSend.sort_by == "color" && bodyToSend.sort_direction == "Desc") {
        colorSymbol = arrowDown
        colorOrder = "d"
      } else if(bodyToSend.sort_by == "cut" && bodyToSend.sort_direction == "Desc") {
        cutSymbol = arrowDown
        cutOrder = "d"
      } else if(bodyToSend.sort_by == "shapes" && bodyToSend.sort_direction == "Desc") {
        shapesSymbol = arrowDown
        cutOrder = "d"
      }
      var diaObjectData = rawDiamondInfo ? rawDiamondInfo.diamondObj.split('_') : ""
      $("#selected-diamond-details").text(`Your Diamond: ${rawDiamondInfo ? rawDiamondInfo.diamondShape : ''} ${parseFloat(diaObjectData[0]).toFixed(2) + "ct"} - ${diaObjectData[4]}`)
      // Appending count on mobile screen
      return `<div class="diamond__right-showing"> 
        <div>
          <p class="hidden-mob-device diamond-text">Select Your Diamond</p>
        </div>
        <div class="right-head">
          <button type="button" onclick="redirectToComparePage()" id="compareDiamondButton" class="vow-btn vow-btn-dark btn-white-border btn-compare-diamonds compare-btn-edit" disabled="true">Compare Diamonds <span>(0/3)</span></button>
          <button type="button" onclick="resetCompareBtn()" id="resetCompareButton" class="vow-btn vow-btn-dark btn-white-border btn-compare-diamonds compare-btn-edit">Reset</button>
        </div>
      </div>
      <div class="selected-daimond-details hide" id="selectedDiamondDetails">
        <h6 class="selected-diamond-name"><img src="https://cdn.shopify.com/s/files/1/1359/2701/files/right_icon_pink.svg?v=1770206620" style="margin-right: 3px;" /> Your Diamond: ${rawDiamondInfo ? rawDiamondInfo.diamondShape : ''} ${parseFloat(diaObjectData[0]).toFixed(2) + "ct"} - ${diaObjectData[4]}</h6>
        <div class="flex">
          <button class="selected-diamond-action deselect${rawDiamondInfo ? rawDiamondInfo.uniqueidentifier : ''}" data-uniqueidentifier="${rawDiamondInfo ? rawDiamondInfo.uniqueidentifier : ''}" onclick="deSelectDiamond(this)" >Remove Diamond</button>
          <button class="selected-diamond-action" id="confirm-diamond-feed">Confirm Selection</button>
        </div>
      </div>
       <div class="table__accordion">
        <div class="table__accordion__inner">
          <div class="table__accordion-item table__accordion-item-head">
            <div class="accordion accordion-header">
            <ul class="emerald__accordion-header">
            <li data-defaultSort="${sortOrder.shapes}" onclick="sortBy('shapes', this)">
            <button href="javascript:void(0)" tabindex="0" aria-label="Shapes">Shape<span class="caratSortIcon">${shapesSymbol}</span></button>
            </li>
            <li data-defaultSort="${sortOrder.carat}" onclick="sortBy('carat', this)">
            <button href="javascript:void(0)" tabindex="0" aria-sort="${sortOrder.carat === 'Desc' ? 'descending' : 'ascending'}" aria-label="Sort by Carat, ${sortOrder.carat === 'Desc' ? 'descending' : 'ascending'}">Carat <span class="caratSortIcon">${caratSymbol}</span></button>
           </li>
           <li data-defaultSort="${sortOrder.color}" onclick="sortBy('color', this)">
           <button href="javascript:void(0)" tabindex="0" aria-sort="${sortOrder.color === 'Desc' ? 'descending' : 'ascending'}" aria-label="Sort by Color, ${sortOrder.color === 'Desc' ? 'descending' : 'ascending'}">Color <span class="caratSortIcon">${colorSymbol}</span></button>
           </li>
           <li data-defaultSort="${sortOrder.clarity}" onclick="sortBy('clarity', this)">
            <button href="javascript:void(0)" tabindex="0" aria-sort="${sortOrder.clarity === 'Desc' ? 'descending' : 'ascending'}" aria-label="Sort by Clarity, ${sortOrder.clarity === 'Desc' ? 'descending' : 'ascending'}">Clarity <span class="caratSortIcon">${claritySymbol}</span></button>
           </li>
          <li tabindex="0">Cut Precision</li>
           <li tabindex="0">Certificate</li>
           <li data-defaultSort="${sortOrder.price}" onclick="sortBy('price', this)" class="pricing-pad">
          <button href="javascript:void(0)" tabindex="0" aria-sort="${sortOrder.price === 'Desc' ? 'descending' : 'ascending'}" aria-label="Sort by Price, ${sortOrder.price === 'Desc' ? 'descending' : 'ascending'}">Price <span class="caratSortIcon">${priceSymbol}</span></button>
          </li>
          <li class="hidden-mob">Details</li>
         <li tabindex="0">Compare</li>
        </ul>
          </div>
          </div>
           ${data.html}
        </div>
      </div>`
    })
    .then(function(htmlToRender) {
      $("#diamond__right").empty();
      document.getElementById("diamond__right").innerHTML = htmlToRender
      /* Managing Sticky Bar Spacing if the announcement bar is set to Sticky */
      var internationalBar = $('.international_announcement_bar');
      var domesticBar = $('.domestic_announcement_bar');
      if (!internationalBar.hasClass('sticky-international') && !internationalBar.hasClass('hide')) {
        $('.table__accordion .table__accordion-item-head').css('top', '80px');
      }
      if (!domesticBar.hasClass('sticky-domestic') && !domesticBar.hasClass('hide')) {
        $('.table__accordion .table__accordion-item-head').css('top', '80px');
      }
    })
    .then(function() {
      allPrice = allPrice.filter( onlyUnique );
      allCarats = allCarats.filter( onlyUnique );
      var minPrice = Math.min.apply(null, allPrice)
      var maxPrice = Math.max.apply(null, allPrice)
      var minCarat = Math.min.apply(null, allCarats)
      var maxCarat = Math.max.apply(null, allCarats)
    })
    .then(function() {
      var acc = document.getElementsByClassName("accordion");
      var dismissPopup = document.getElementsByClassName("dismiss-popup");
      var i;
      var priceSortIcon = `<svg class="sort-arrow" width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <line x1="13.2929" y1="7" x2="7" y2="0.707107" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
                            <line x1="7" y1="0.707107" x2="0.707107" y2="7" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
                          </svg>`;
      var arrowUp = `<svg class="sort-arrow" width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <line x1="13.2929" y1="7" x2="7" y2="0.707107" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
                      <line x1="7" y1="0.707107" x2="0.707107" y2="7" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>`;
      for (i = 0; i < acc.length; i++) {
        acc[i].addEventListener("click", function(){
          var uniqueId = this.getAttribute("data-cert_num")
          var isOpen = this.classList.contains("active");
          $(".panel").removeAttr('style').css("display", "none");
          $(".accordion").removeClass("active");
          $(".btn-view-details").html(priceSortIcon)
          if (isOpen) {
            return;
          }
          $(this).find(".btn-view-details").html(priceSortIcon)
          if( uniqueId ) {
            var urlToPush = updateQueryStringParameter(window.location.href, 'did', uniqueId)
            history.pushState({}, "", urlToPush)
            if (this.classList['value'] === 'accordion active') {
              $(".panel").removeAttr('style').css("display","none")
              $(this).find(".btn-view-details").html(priceSortIcon)
            } else {
              $(".panel").css("display","none")
              $(this).find(".btn-view-details").html(arrowUp)
              getDiamondVideo(this)
              var panel = this.nextElementSibling;
              if(panel) {
                if (panel.style.display === "block") {
                  panel.style.display = "none";
                } else {
                  panel.style.display = "block";
                }
              }
            }
            this.classList.toggle("active");
          }
        });
      }
      for (i = 0; i < dismissPopup.length; i++) {
        dismissPopup[i].addEventListener("click", function(){
          $(".panel").removeAttr('style').css("display", "none");
          $(".accordion").removeClass("active");
        });
      }
      $(".siteLoader").hide()
      /* Managing Spacing if diamond is selected */
      if (window.innerWidth > 768) {
        if (_raw_diamond_info) {
          if ($('.table__accordion-item-active').length) {
            $('.table__accordion-item').addClass('manage-active-class-space');
          }
        }
      }
      /* Show Selected Diamond Data */
      if(rawDiamondInfo){
        $('#confirm-diamond-feed, #confirm-diamond-feed-mobile').click(function() {
          var grabProductHandle = getParameterByName("productHandle") 
          if(grabProductHandle){
            document.getElementById("ChooseSize").click();
          } else {
            document.getElementById("chooseSettings").click();
          }
        });
        $('#selectedDiamondDetails').removeClass('hide')
        $('#diamond-details-mobile').removeClass('hide')
      } else {
        $('#selectedDiamondDetails').addClass('hide')
        $('#diamond-details-mobile').addClass('hide')
      }
      
      if(window.location.href.includes('did=')) {
        if (!window.matchMedia("(max-width: 767px)").matches)  {
          window.scrollTo(0,document.body.scrollHeight); // #1 Browser scroll should be at bottom
          document.querySelector("#diamond__right").scrollIntoView({ behavior: "smooth" }); // #2 Then feed scroll will work
        }
        let diamondIdNew = (window.location.href.split('did=')[1]).split('&')[0]
        if($(`[data-aid=accordion${diamondIdNew}]`).length > 0) {
          $(`[data-aid=accordion${diamondIdNew}]`).click()
          var parentPos = document.querySelector('.table__accordion__inner').getBoundingClientRect()
          var childPos = document.querySelector(`div[data-aid='accordion${diamondIdNew}']`).getBoundingClientRect()
          let rr = document.querySelector(`div[data-aid='accordion${diamondIdNew}']`)
          let topPos = childPos.top - parentPos.top - 43
          setTimeout(function() {
            if (window.matchMedia("(max-width: 767px)").matches) {
              var topPosa = rr.offsetTop
              window.scrollTo({top: topPosa, behavior: 'smooth'})
            } else {
              document.querySelector(".table__accordion__inner").scrollTo({top: topPos, behavior: 'smooth'})
            }
          }, 1000)
        } else {
          $("#shared-diamond-notpreset").show()
        }
      }
    })
    .then(function(){
      // Setting the checkboxes of diamond
      var certNums = getComparedDiamonds()
      updateCheckboxUi(certNums)
      // If diamond is shared then show active class
      if(diamondIdToShowOnTop) {
        let diamondDefaultName = getDiamondOtherNames(getDiamond())[0]
        $(`li[data-val="${diamondDefaultName}"]`).addClass("active")
        $("#engaged").val(diamondDefaultName)
      }
    })
    .then(function() {
      if($('.table__accordion__inner').find('.withoutsoldout') && $('.table__accordion__inner').find('.withoutsoldout').length < 8){
        var appendLessDataNote = '<div class="show_less_data_message"><h5> Interested in additional options or need assistance in finding the perfect diamond? Our experts are here to help. <a target="_blank" href="/pages/design-an-engagement-ring" class="bridal-chat-btn" tabindex="0">Contact us now</a>!</h5></div>';
        $('.table__accordion__inner').append(appendLessDataNote)
      }
    })
    .then(function() {
      setDropdownActiveClass()
    })
    .catch(error => console.log(error, "error from rapne"))
  }
}
 
async function saveDiamond(e) {
  const boxClass = $(window).width() >= 768 ? "product-diamond-shape-selection" : "ProductForm__mobile-view";
  $(".siteLoader").show();
  $(e).attr("disabled", true);
  $(".table__accordion-item").removeClass("table__accordion-item-active");
  try {
    const response = await fetch("/cart.js");
    if (!response.ok) throw new Error("Failed to fetch cart data");
    const cartJson = await response.json();
    const diamondId = $(e).attr("data-diamondId");
    const certNum = $(e).attr("data-cert_num");
    const diamondSource = $(e).attr("data-source");
    var diamondShape = $(e).attr("data-shape");
    const diamondObj = $(e).attr("data-objs");
    const selectDiamond = $(e).attr("data-selectDiamond");
    const grabSelectedDiamondType = $(e).attr("data-isLgTrue");
    const uniqueidentifier = $(e).attr("data-uniqueIdentifier");
    const diamondTotalSalesPrice = $(e).attr("data-total-sales-price");
    const diamondMarkupPrice = $(e).attr("data-diamond-markup-price");
    const diamondTitle = `${diamondShape} #${certNum}`;
    const getProductHandle = getParameterByName("productHandle");
    const getVariantId = getParameterByName("variantId");
    const getSelectedMetal = getParameterByName("metal");
    const getSelectedRingSize = getParameterByName("ringSize");
    const getDiamondTypeParam = getParameterByName("diamondLabType");
    var selectedDiamondType = "natural";

    if(grabSelectedDiamondType && grabSelectedDiamondType === "true"){
      selectedDiamondType = "lab"
    }
    
    localStorage.setItem('get_diamond_total_sale_price', JSON.stringify({ diamondTotalSalesPrice }));
    localStorage.setItem('get_diamond_markup_price', JSON.stringify({ diamondMarkupPrice }));
    localStorage.setItem('select_main_product_data', JSON.stringify({ getProductHandle, getVariantId, getSelectedMetal, getSelectedRingSize }));

    const resultArray = cartJson.items.filter(item =>
      item.properties && (item.product_type === "Diamond" || item.product_type === "Vow Engagement Rings")
    );

    if (resultArray.length) {
      $(".siteLoader").hide();
      localStorage.setItem("_vow_item_cart", JSON.stringify(resultArray));
      localStorage.setItem("_clicked_button_cert_id", JSON.stringify(certNum));
      $("#already-diamond-popup").addClass("open");
      $(e).attr("disabled", false);
      return;
    }

    var diamondType = getParameterByName("diamondType")
    if(diamondType === 'Emerald (North/South)' || diamondType === 'Emerald+(North/South)') diamondShape = 'Emerald (North/South)';
    if(diamondType === 'Emerald (East/West)' || diamondType === 'Emerald+(East/West)') diamondShape = 'Emerald (East/West)';

    localStorage.setItem('_raw_diamond_info', JSON.stringify({
      diamondId, certNum, diamondSource, diamondShape, diamondObj, selectDiamond, uniqueidentifier, diamondTitle, selectedDiamondType
    }));
    $(e).closest(".table__accordion-item").addClass("table__accordion-item-active");

    if (window.innerWidth > 768 && localStorage.getItem('_raw_diamond_info') && $('.table__accordion-item-active').length) {
      $('.table__accordion-item').addClass('manage-active-class-space');
    }

    if (!certNum) throw new Error("certNum is empty");

    let data = null;
    try {
      const shopifyResponse = await fetch(diamondApiUrl + '/getshopifyapi', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          apiUrl: apiUrlPath + apiVersion + "products.json?handle=" + certNum,
          method: 'GET'
        })
      });
      if (!shopifyResponse.ok) throw new Error("Failed to fetch Shopify API");
      const shopifyData = await shopifyResponse.json();
      data = shopifyData.products[0];
    } catch (error) {
      console.warn("Shopify API fetch error:", error);
    }

    $(".siteLoader").hide();

    if (data) {
      if (data.variants && data.variants.length) {
        localStorage.setItem('seletedDiamond', JSON.stringify(data));
        localStorage.setItem('selectedDiamondCompleteData', JSON.stringify(data));
        redirectToProductDetailPage(diamondShape);
      } else {
        console.log("This diamond doesn't have any variants");
      }
    } else {
      try {
        const diamondResponse = await fetch(`${diamondApiUrl}/diamonds/getSingle`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ cert_num: certNum })
        });
        if (!diamondResponse.ok) throw new Error("Failed to fetch diamond data");
        const diamondInfo = await diamondResponse.json();
        const diamond = diamondInfo.response.body.diamond;
        const diamondSeller = diamondInfo && diamondInfo.response && diamondInfo.response.body ? diamondInfo.response.body.seller : false;
        const sellerName = diamondSeller ? `${vendorId(diamond.rapnet_account_id)}-` : '';
        const diamondSellerName = diamondSeller ? `${vendorId(diamond.rapnet_account_id)}` : '';
        const ringSize = $(`.${boxClass}`).find(".ProductForm__SelectedValue__Ringsize").text();
        const diamondShapeId = shapeId(diamond.shape);
        const markedUpPrice = diamond.marked_up_price ? diamond.marked_up_price.toFixed(2) : '0';
        let originalPrice = diamond.total_sales_price_in_currency ? diamond.total_sales_price_in_currency : 'N/A'
        if (diamond.source == "Rapnet") {
          originalPrice = diamond.total_purchase_price ? diamond.total_purchase_price : 'N/A'
        }
        let skuString = `BE-${sellerName}${diamond.stock_num}-${diamondShapeId}-${certNum}`;
        if (getParameterByName('diamondLabType') === "lab") skuString += "-LG";

        const product = {
          title: `${diamond.shape} #${certNum}`,
          vendor: vendorId(diamond.rapnet_account_id),
          product_type: 'Diamond',
          handle: certNum,
          taxable: true,
          variants: [{
            inventory_management: "shopify",
            inventory_quantity: 1,
            position: 1,
            price: markedUpPrice,
            taxable: true,
            requires_shipping: true,
            sku: skuString
          }],
          tags: [
            `size: ${diamond.size || 'N/A'}`,
            `shape: ${diamond.shape || 'N/A'}`,
            `measurements: ${diamond.meas_length} x ${diamond.meas_width} x ${diamond.meas_depth}`,
            `price: ${originalPrice}`,
            `diamondId: ${diamond.diamond_id || 'N/A'}`,
            `ringSize: ${ringSize || 'N/A'}`,
            `color: ${diamond.color || 'N/A'}`,
            `clarity: ${diamond.clarity || 'N/A'}`,
            `symmetry: ${diamond.symmetry || 'N/A'}`,
            `polish: ${diamond.polish || 'N/A'}`,
            `cut: ${diamond.shape === "Round" ? diamond.cut : 'Excellent'}`,
            `cert_num: ${certNum}`,
            `stock_num: ${diamond.stock_num || 'N/A'}`,
            `image_file_url: ${diamond.image_file_url || ''}`,
            `YBlocklist`,
            `diamond-product`,
            `ll-exclusion`,
            `${getVendorIdByName(diamondSellerName) ? getVendorIdByName(diamondSellerName) : ''}`
          ]
        };
        /* Check Lab Grown Diamond through Vendor or Product Tag */
        var isLabGrown = false;
        const labGrownVendors = ['SL', 'GR', 'FN', 'MD', 'Aarush', 'RC', 'EL', 'OML'];
        if (labGrownVendors.includes(diamond.source)) {
          isLabGrown = true;
        }
        if (diamond.lg === true || isLabGrown) product.tags.push("LG");

        localStorage.setItem('seletedDiamond', JSON.stringify(product));
        createDiamondProduct(product);
      } catch (error) {
        console.error("Diamond data fetch error:", error);
        showErrorMessage("Failed to fetch diamond data");
        $(e).removeClass('hide').attr("disabled", false);
      }
    }
  } catch (error) {
    console.error("Error in saveDiamond:", error);
    showErrorMessage(error.message || "An error occurred");
  } finally {
    $(".siteLoader").hide();
  }
}

/* Creating Diamond Product when user selects any Diamond */
function createDiamondProduct(diamond) {
  const diamondShape = diamond.title.split(" #")[0];
  const requestOptions = {
    method: 'POST',
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify({ product: diamond }),
    redirect: 'follow'
  };
  fetch(`${storePrivateApiUrl}/product?shop=${storeUrlJs}`, requestOptions)
    .then(async (response) => {
      if (!response.ok) {
        throw new Error(`Failed to create diamond product: ${response.statusText}`);
      }
      const result = await response.json();
      const createdProduct = result.product;
      if (createdProduct?.variants?.length) {
        localStorage.setItem('selectedDiamondCompleteData', JSON.stringify(createdProduct));
        // Save the product's default image
        saveDiamondProductImage(
          createdProduct.id,
          diamond,
          removeCharWithLowerCase(diamondShape),
          (error, data) => {
            console.log(error ? "Add image error" : "Add image success", error || data);
          }
        );
      } else {
        console.warn("Diamond product created without variants:", createdProduct);
      }
    })
    .catch((error) => {
      console.error('Error creating diamond product:', error.message || error);
    });
}

/* Saving Selected Diamond Image to Shopify */
function saveDiamondProductImage(productId, product, shape) {
  const defaultImageUrl = 'https://rc-diamond-images.s3.us-east-2.amazonaws.com/defaultDiamondImages/noImage.png';
  const shapeImageUrls = {
    "round": 'https://cdn.shopify.com/s/files/1/1359/2701/files/round.png',
    "oval": 'https://cdn.shopify.com/s/files/1/1359/2701/files/oval.png',
    "pear": 'https://cdn.shopify.com/s/files/1/1359/2701/files/pear.png',
    "radiant": 'https://cdn.shopify.com/s/files/1/1359/2701/files/radiant.png',
    "cushion": 'https://cdn.shopify.com/s/files/1/1359/2701/files/cushion.png',
    "emerald": 'https://cdn.shopify.com/s/files/1/1359/2701/files/emrald.png',
    "antique-styleround": 'https://cdn.shopify.com/s/files/1/1359/2701/files/antiquestyleround.png',
    "antiquestyleround": 'https://cdn.shopify.com/s/files/1/1359/2701/files/antiquestyleround.png',
    "antique-stylecushion": 'https://cdn.shopify.com/s/files/1/1359/2701/files/antiquestylecushion.png',
    "antiquestylecushion": 'https://cdn.shopify.com/s/files/1/1359/2701/files/antiquestylecushion.png',
    "marquise": 'https://cdn.shopify.com/s/files/1/1359/2701/files/marquise_pink.jpg?v=1702374856'
  };

  if (!productId || !shape) {
    console.warn("Missing productId or shape. Cannot proceed with saving diamond product image.");
    $(".siteLoader").hide();

    var diamondType = getParameterByName("diamondType")
    if(diamondType === 'Emerald (North/South)' || diamondType === 'Emerald+(North/South)') shape = 'Emerald (North/South)';
    if(diamondType === 'Emerald (East/West)' || diamondType === 'Emerald+(East/West)') shape = 'Emerald (East/West)';

    redirectToProductDetailPage(shape);
    return;
  }

  const imageTag = product?.tags?.find(tag => tag.startsWith("image_file_url:")); // Determine the image URL
  const imageUrl = shapeImageUrls[shape] || (imageTag ? imageTag.replace("image_file_url: ", "") : "") || defaultImageUrl; // Prioritize Images
  const body = {
    apiUrl: `${apiUrlPath}${apiVersion}products/${productId}/images.json`,
    method: 'POST',
    data: {
      image: {
        src: imageUrl,
        filename: "defaultDiamondImage.png"
      }
    }
  };

  commonApiCalls(body, (error, response) => {
    if (error) {
      console.log("Error saving diamond product image:", error);
    } else {
      console.log("Successfully saved diamond product image:", response);
    }
    $(".siteLoader").hide();
    
    var diamondType = getParameterByName("diamondType")
    if(diamondType === 'Emerald (North/South)' || diamondType === 'Emerald+(North/South)') shape = 'Emerald (North/South)';
    if(diamondType === 'Emerald (East/West)' || diamondType === 'Emerald+(East/West)') shape = 'Emerald (East/West)';
    redirectToProductDetailPage(shape);
  });
}

function getVideoUrlFromRdi(stockId, cb) {
  const body = {
    apiUrl: `https://api.rdidiamonds.com/v1/check-media/${stockId}?key=hfjfHVhPuy9VhUNQ4SFrz5w9`,
    method:'GET'
  }
  commonApiCalls(body, (data) => {
    cb(null, data)
  })
}

function getDiamondVideo(e) {
  let diamondId   = e.getAttribute("data-diamondid")
  let stockNumber = e.getAttribute("data-stockNumber")
  let cert_num = e.getAttribute("data-cert_num")
  let rapnet_account_id = e.getAttribute('data-rapnet_account_id')
  let videourl = e.getAttribute('videourl')
  let uniqueid = e.getAttribute('uniqueid')
  let videoPanel = $("#panel__inner"+cert_num)
  if(cert_num) {
    if (videourl !== '' && stockNumber !== '') {
      if (videourl.indexOf('360diamondview') !== -1) {
        videourl = videourl.replace("&zoomslide=0", '')
      } else if(videourl.indexOf('//v360.in/') !== -1 && videourl.indexOf('&sv=1') === -1){
        videourl = videourl+"&sm=0&sv=1&zoomslide=0"
      } 
      
      if(videourl !== ''){
        if (videourl.indexOf('sv=1') === -1 || videourl.indexOf('sv=2') === -1){
          videourl = videourl.replace("sv=1","sv=0")
          videourl = videourl.replace("sv=2","sv=0")
        }
      }

      let existsUrl = $("#panel__inner"+cert_num).find(`#frames${uniqueid}`).attr('src')
      if (videourl !== '' && existsUrl !== videourl) {
        $(videoPanel).html(`<div class="VideoWrapper360">
          <div class="framesloader${uniqueid} loader__section"><div class="loader loader-20"><div class="css-diamond"></div></div></div>
          <iframe tabindex="-1" onload="hideFrameLoader(${uniqueid})" loading="lazy" id="frames${uniqueid}" allow="accelerometer; autoplay;"  allowtransparency="true" src="${videourl}"></iframe></div>`);
      } else if (videourl === '' && existsUrl !== videourl) {
        $(videoPanel).html('<div style="position: absolute;left: 0;right: 0;top: 0;bottom: 0;margin: auto;height: 22px;text-align: center;font-style: italic;font-size: 15px;line-height: 20px;letter-spacing: 0.05em;color: #000000;">Video of the diamond</div>')
      }
    } else if (cert_num) {
      if (stockNumber) {
        getVideoUrlFromRdi(stockNumber, (e, d) => {
          if(!e) {
            // If videos are present
            if(d.exists) {
              let versions = d.versions[1]
              if (!versions || versions.num_images == "") {
                versions = d.versions[0]
              }
              let image = versions.md_first_image.replace("000", "{frame}")
              $(videoPanel).spritespin({
                source: SpriteSpin.sourceArray(image, { frame: [0, (versions.num_images-1)], digits: 3 }),
                width   : 325,  // width in pixels of the window/frame
                animate: true,
                detectSubsampling: true,
                loop: true,
                sense: -1,
                responsive: true,
                frameTime: 82,
                retainAnimate: !0,
                plugins: [
                  '360',
                  'drag'
                ],
                onInit: function() {
                  $(videoPanel).append(`<div class="loadersprite11${stockNumber} loader__section"><div class="loader loader-20"><div class="css-diamond"></div></div></div>`);
                },
                onComplete: function() {
                  $(`.loadersprite11${stockNumber}`).fadeOut('slow', function(){
                    $(`.loadersprite11${stockNumber}`).remove();
                  });
                }
              })
            } else {
              $(videoPanel).html('<div style="position: absolute;left: 0;right: 0;top: 0;bottom: 0;margin: auto;height: 22px;text-align: center;font-style: italic;font-size: 15px;line-height: 20px;letter-spacing: 0.05em;color: #000000;">Video of the diamond</div>')
            }
          } else {
            $(videoPanel).html('<div style="position: absolute;left: 0;right: 0;top: 0;bottom: 0;margin: auto;height: 22px;text-align: center;font-style: italic;font-size: 15px;line-height: 20px;letter-spacing: 0.05em;color: #000000;">Video of the diamond</div>')
          }
        })
      } else {
        $(videoPanel).html('<div style="position: absolute;left: 0;right: 0;top: 0;bottom: 0;margin: auto;height: 22px;text-align: center;font-style: italic;font-size: 15px;line-height: 20px;letter-spacing: 0.05em;color: #000000;">Video of the diamond</div>')
      }
    } else {
      $(videoPanel).html('<div class="VideoWrapper360"><iframe src="https://360diamondview.com/video/6331585840.html?sm=0&zoomslide=0"></iframe></div>')
    }
  } else {
    console.log(`cert_num is empty`)
  }
}

function deSelectDiamond(e) {
  var uniqueIdentifier = $(e).attr("data-uniqueIdentifier")
  $(e).addClass('hide')
  $(".table__accordion-item").removeClass("table__accordion-item-active")
  $(`.select${uniqueIdentifier}`).removeClass('hide').text('Select This Diamond')
  $("#selectedDiamondShape").val('')
  $("#selectedDiamondId").val('')
  $("#selectedDiamondObj").val('')
  $("span.selectedDiamond").text('Select')
  /* Managing Spacing once user deselects diamond */
  if (window.innerWidth > 768) {
    var _raw_diamond_info = localStorage.getItem('_raw_diamond_info');
    if (_raw_diamond_info) {
      if ($('.table__accordion-item').length) {
        $('.table__accordion-item').removeClass('manage-active-class-space');
      }
    }
  }
  removeVowLocalstorageItems()
  $('#ChooseSize').removeClass('show-hand-cursor').removeAttr('onclick')
  $('#selectedDiamondDetails').addClass('hide');
  $('#diamond-details-mobile').addClass('hide');
  $('#diamondDetailsThreeStep').remove();
  $('#viewChangeDiamond').remove();
  $('#totalCostCalculator').remove();
  $('#step-three-review-design').removeClass('selected')
}

function toggleDiamond(value) {
  var allDiamond = getDiamond()
  var index = allDiamond.indexOf(value);
  if(value.indexOf(",") !== -1) return allDiamond
  if (index === -1) {
    allDiamond.push(value);
  } else if (allDiamond.length !== 1){
    allDiamond.splice(index, 1);
  }
  return allDiamond
}

function getFeedByDiamondForMobile(e) {
  var value = jQuery(e).val()
  var allDiamondValueToSend = toggleDiamond(value)
  feedOnDiamondChange(allDiamondValueToSend)
}

function getFeedByDiamond(e) {
  var value = jQuery(e).attr("data-value")
  if(jQuery(e).parent().hasClass("active")){
    jQuery(e).parent().removeClass("active")
    /* Managing space on click of Antique Style Cushion */
    if(value === 'Antique-Style Cushion' || value === 'Antique-Style Round'){
      $('.filter__section').removeClass('filter__section__space')
      $('.diamond__shape').removeClass('diamond__shape__space')
    }
  } else {
    jQuery(e).parent().addClass("active")
    /* Managing space on click of Antique Style Cushion */
    if(value === 'Antique-Style Cushion' || value === 'Antique-Style Round'){
      $('.filter__section').addClass('filter__section__space')
      $('.diamond__shape').addClass('diamond__shape__space')
    }
  }
  if($(".diamondshape").find("li.active").length === 0){
    jQuery(e).parent().addClass("active")
  }
  var allDiamondValueToSend = toggleDiamond(value)
  var grabLatestDiamond = allDiamondValueToSend[allDiamondValueToSend.length - 1];
  $("#chooseSettings, #viewProuctSetting").attr("onclick",`updateURLParamAndRedirect('${grabLatestDiamond ? grabLatestDiamond : ''}')`);
  
  // delete bodyToSend.price_total_from
  // delete bodyToSend.price_total_to
  delete bodyToSend.size_from
  delete bodyToSend.size_to
  delete bodyToSend.color_from
  delete bodyToSend.color_to
  delete bodyToSend.clarity_from
  delete bodyToSend.clarity_to
  feedOnDiamondChange(allDiamondValueToSend)
  setDropdownActiveClass()
}

function feedOnDiamondChange(value) {
  if(value) {
    $(".siteLoader").show()
    var productHandle = getParameterByName("productHandle")
    var diamondType = value
    if (productHandle) {
      fetch("/collections/all/products/"+productHandle+".json", {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        }
      })
      .then(response => response.json())
      .then((data) => {
        vowProduct = data.product
        return vowProduct
      })
      .then(function(vowProduct) {
        // Getting parameters by name
        var metal       = null
        var variantId   = getParameterByName("variantId")
        var productHandleDesignDetail = null
        
        /** * Getting the product metal and design detail from previous metal * **/
        if (variantId) {
          vowProduct.variants.map(function(data, i) {
            if(data.id == variantId) {
              productHandleDesignDetail = data.option3
              if(!metal) {
                metal = data.option2
              }
            }
          })
        } else {
          console.log("variantId is not present")
        }
        if (metal && diamondType && vowProduct) {
          var variantInfo = getVowProductVariantInfo(vowProduct, diamondType, metal, productHandleDesignDetail)
          let urlWithoutDid = getUrlWithoutDid()
    	    let str1 = updateQueryStringParameter(urlWithoutDid, 'diamondType', value.join(','))
          let str2 = updateQueryStringParameter(str1, 'variantId', variantInfo?.id)
          let str3 = updateQueryStringParameter(str2, 'metal', variantInfo.option2)
          let str4 = updateQueryStringParameter(str3, 'page', 1)
          history.pushState({}, "", str4)
          /* Re-initializing local-storage data for selected Diamond shapes */
          let storageEntry = localStorage.getItem('_bodyToSend');
          if (storageEntry && storageEntry !== null) {
            let storageObject = JSON.parse(storageEntry);
            storageObject.shapes = diamondType
            let updatedStorageEntry = JSON.stringify(storageObject);
            localStorage.setItem('_bodyToSend', updatedStorageEntry);
          }
          return str4
        }
      })
      .then(function(str3){
        generateFeedData()
      })
	} else if (isSelectDiamondFirst === 'true') {
      let urlWithoutDid = getUrlWithoutDid();
      let updatedUrl = updateQueryStringParameter(urlWithoutDid, 'diamondType', value.join(','));
      Promise.resolve()
        .then(() => {
          updatedUrl = updateQueryStringParameter(updatedUrl, 'page', 1);
          history.pushState({}, "", updatedUrl);
        })
        .then(() => {
          let storageEntry = localStorage.getItem('_bodyToSend');
          if (storageEntry) {
            let storageObject = JSON.parse(storageEntry);
            storageObject.shapes = diamondType;
            localStorage.setItem('_bodyToSend', JSON.stringify(storageObject));
          }
        })
        .then(function(updatedUrl) {
          // Call to generate feed data only once
          generateFeedData();
        })
      .catch(error => {
        console.error('Error updating URL or processing data:', error);
      });
    } else {
      console.log("Product handle is empty")
      window.location.href = `/collections/${js_vow_collection_page}`
    }
  }
}

/** * This function return an array of cert_nums which are clicked and present in localstorage * **/
function getComparedDiamonds() {
  // Getting the diamonds to compare from localstorage
  var certNums = localStorage.getItem('_diamonds_to_compare') ? JSON.parse(localStorage.getItem( '_diamonds_to_compare')) : []
  // Pushing the new clicked certificate numbers in it
  jQuery('input[type="checkbox"]:checked').each(function() {
    var tmpCertNum = jQuery(this).attr("data-cert_num")
    certNums.push(tmpCertNum)
  });
  // Only unique values setting in array
  certNums = certNums.filter(onlyUnique)
  let newCertNums = certNums.filter(function(cert) {
    if (cert) {
      return cert
    }
  })
  return newCertNums
}

/** * Handle of checkbox onclick button * **/
function compareThisDiamond(e) {
  var comparedDiamonds = getComparedDiamonds();
  var clickedElementCert = jQuery(e).attr("data-cert_num");
  const isChecked = e.checked;
  if (clickedElementCert) {
    // Synchronize all checkboxes with the same data-cert_num
    var checkboxes = jQuery(`.compare_diamond_selector[data-cert_num="${clickedElementCert}"]`);
    checkboxes.prop('checked', isChecked).attr('aria-checked', isChecked);
    if (isChecked) {
      comparedDiamonds.push(clickedElementCert);
      comparedDiamonds = comparedDiamonds.filter(onlyUnique);
      jQuery(`.vow-btn-dark-outline[data-cert_num="${clickedElementCert}"]`).text("Added to compare");
    } else {
      comparedDiamonds = comparedDiamonds.filter(certnum => certnum !== clickedElementCert);
      jQuery(`.vow-btn-dark-outline[data-cert_num="${clickedElementCert}"]`).text("Add to compare");
    }
    localStorage.setItem("_diamonds_to_compare", JSON.stringify(comparedDiamonds));
    updateCheckboxUi(comparedDiamonds);
  } else {
    console.log("certNums is empty for this checkbox");
  }
}


function resetCompareBtn() {
  localStorage.removeItem('_diamonds_to_compare');
  $('#compareDiamondButton, #compareDiamondButtonMobile').html('Compare Diamonds <span>(0/3)</span>');
  $("#compareDiamondButton, #compareDiamondButtonMobile").prop("disabled", true)
  $(".compare-checkbox").attr("disabled", false)
  $('input[type="checkbox"]').attr("disabled", false)
  $(".table__accordion-item .vow-btn-dark-outline").attr("disabled", false)
  $('.compare_diamond_selector').prop('checked', false);
}   

function updateCheckboxUi( certNums ) {
  // Appending values at button
  jQuery("#compareDiamondButton>span, #compareDiamondButtonMobile>span").text(`(${certNums.length}/3)`)
  if (certNums.length == 2) {
    jQuery("#compareDiamondButton, #compareDiamondButtonMobile").attr("disabled", false)
    jQuery(".compare-checkbox").attr("disabled", false)
    jQuery('input[type="checkbox"]').attr("disabled", false)
  } else if (certNums.length == 1) {
    jQuery("#compareDiamondButton, #compareDiamondButtonMobile").attr("disabled", false)
    jQuery(".compare-checkbox").attr("disabled", false)
    jQuery('input[type="checkbox"]').attr("disabled", false)
  } else if(certNums.length > 2) {
    jQuery("#compareDiamondButton, #compareDiamondButtonMobile").attr("disabled", false)
    jQuery(".compare-checkbox").attr("disabled", false)
    jQuery('input[type="checkbox"]').attr("disabled", false)
    jQuery('input[type="checkbox"]').each(function() {
      // If checkbox is not checked
      if( !$(this).is(':checked') ) {
        // Disabled the span of checkbox
        jQuery(this).closest(".compare-checkbox").attr("disabled", true)
        $(this).prop("disabled", true);
        var certNum = jQuery(this).attr("data-cert_num")
        if(certNum) {
          jQuery(`.vow-btn-dark-outline[data-cert_num="${certNum}"]`).attr("disabled", true)
        }
      }
    })
  } else {
    jQuery("#compareDiamondButton, #compareDiamondButtonMobile").attr("disabled", true)
    jQuery(".compare-checkbox").attr("disabled", false)
    jQuery('input[type="checkbox"]').attr("disabled", false)
    jQuery(".table__accordion-item .vow-btn-dark-outline").attr("disabled", false)
  }
}

function triggerCheckBox(e) {
  var certNum = jQuery(e).attr("data-cert_num")
  if (certNum) {
    jQuery(`input[data-cert_num="${certNum}"]`).trigger("click")
  }
}

function redirectToComparePage() {
  var certNums   = getComparedDiamonds()
  var variantId  = null
  var urlParams  = []

  if(certNums.length > 0) {
    var urlparam = certNums.join(",")
    urlParams.push("cert_num="+urlparam)
    variantId = getParameterByName("variantId")
    if (variantId) {
      urlParams.push("variantId="+variantId)
    }
    
    var metal= getParameterByName("metal")
    var decodedMetal = decodeURIComponent(metal);
    var selectedMetal = decodedMetal.replace(/\s+/g, '');
    if (selectedMetal) {
      urlParams.push("metal="+selectedMetal)
    }

    var productHandle = getParameterByName("productHandle")
    if (productHandle) {
      urlParams.push("productHandle="+productHandle)
    }

    var diamondType = getParameterByName("diamondType")
    if(!diamondType) {
    	console.log("diamondType parameter is required in url")
    } else {
      urlParams.push("diamondType="+diamondType)
    }
    
    var diamondLabType = getParameterByName("diamondLabType")
    if(!diamondLabType) {
      urlParams.push("diamondLabType=natural")
    } else {
      urlParams.push("diamondLabType="+diamondLabType)
    }

    var grabRingSize = getParameterByName("ringSize")
    if (grabRingSize) {
      urlParams.push("ringSize="+grabRingSize)
    }
    
    var selectDiamondFirstInfo = getParameterByName("selectDiamondFirst")
    if(selectDiamondFirstInfo) {
      urlParams.push("selectDiamondFirst="+selectDiamondFirstInfo)
    }   

    var isSelectWithDiamondFirst = getParameterByName('startwithsetting');
    if(isSelectWithDiamondFirst && isSelectWithDiamondFirst === 'true') {
      urlParams.push("startwithsetting=true")
    } 
    
    window.location.href = "/pages/diamond-compare?"+urlParams.join("&")
  } else {
  	console.log("Please select diamond to compare")
  }
}

function setBodyParams() {
  var newBodyToSend = {}
  let oldParams = getBodyParams()
  if( oldParams ) {
  	newBodyToSend = oldParams
  }
  let newBodyToSet = Object.assign( {}, oldParams, bodyToSend )
  // Saving the lastfilter data in localstorage
  localStorage.setItem("_bodyToSend", JSON.stringify(newBodyToSet));
}

function getBodyParams() {
  let bodyToSendData = localStorage.getItem("_bodyToSend")
  var isdrawerOpened = localStorage.getItem("_isDrawerOpened")
  var diamondType = getParameterByName('diamondLabType') === 'natural';
  var parsedData = JSON.parse(bodyToSendData);
  if (bodyToSendData) {
    if ('fluor_intensity' in parsedData || 'ratio_max' in parsedData) {
      filterApplied = true
    }
    if(isdrawerOpened == 'true' && filterApplied == true && $(".additional-param-link").find(".priceSortIcon").hasClass("priceSortIcon-rotate")){
      $(".additional-param-link").click();
    }
    if(parsedData && parsedData?.price_total_from < minNaturalDiamondPrice) {
      parsedData.price_total_from = minNaturalDiamondPrice
      parsedData.price_total_to = diamondType ? maxNaturalDiamondPrice: maxLabGrownDiamondPrice
    }
    if(parsedData && !parsedData?.price_total_from) {
      parsedData.price_total_from = diamondType ? minNaturalDiamondPrice : minLabGrownDiamondPrice
    }
    if(parsedData && !parsedData?.price_total_to) {
      parsedData.price_total_to = diamondType ? maxNaturalDiamondPrice: maxLabGrownDiamondPrice
    }
    if(bodyToSendData) {
      return parsedData
    } else {
      return null
    }
  }
}

function browseMoreDiamonds(e) {
  window.location.href = getUrlWithoutDid()
}

function getUrlWithoutDid() {
  if(window.location.search && window.location.search.length > 0){
    let items = window.location.search.split("&")
    if( items && items.length > 0) {
      let newItems = []
      items.map(function(item, i){
        if( item.indexOf("did=") === -1 ){
          newItems.push(item)
        }
      })
      return window.location.pathname+newItems.join("&")
    }
  } else {
    return null
  }
}

function socialWindow(url) {
  var left = (screen.width - 570) / 2;
  var top = (screen.height - 570) / 2;
  var params = "menubar=no,toolbar=no,status=no,width=570,height=570,top=" + top + ",left=" + left;
  window.open(url,"NewWindow",params);
}

function setShareLinks() {
  let pageUrl = encodeURIComponent(document.URL);

  $(".social-share.facebook").on("click", function() {
    let url = "https://www.facebook.com/sharer.php?u=" + pageUrl;
    socialWindow(url);
  });
  $(".social-share.twitter").on("click", function() {
    let url = "https://twitter.com/intent/tweet?url=" + pageUrl;
    socialWindow(url);
  });
  $(".social-share.pinterest").on("click", function() {
    var imgSource = document.getElementById('banner__image').src;
    let url = "https://www.pinterest.com/pin/create/link/?url="+pageUrl+"&description=SHARE WITH SOMEONE SPECIAL&media="+imgSource
    socialWindow(url);
  });
  $(".social-share.mail_to").on("click", function() {
     let url = "https://mail.google.com/mail/?view=cm&ui=2&tf=0&fs=1&to=&su=SHARE WITH SOMEONE SPECIAL&body="+ pageUrl;
     socialWindow(url);
  });
  $(".social-share.text_message").on("click", function() {
    var ua = navigator.userAgent.toLowerCase();
  	var urll = "sms:";
  	urll += (ua.indexOf("iphone") > -1 || ua.indexOf("ipad") > -1) ? "&" : "?";
  	urll += "body=" + pageUrl;
  	location.href = urll;
  });
}

function showHide() {
  var x = document.getElementById("share-popup");
  if (x.style.display === "block") {
    x.style.display = "none";
  } else {
    x.style.display = "block";
  }
  setShareLinks();
  var $temp = $("<input>");
  var $url = $(location).attr('href');
  var message = "Link Copied"
  $('.clipboard').on('click', function() {
  $("body").append($temp);
  $temp.val($url).select();
  document.execCommand("copy");
  $temp.remove();
   showErrorMessage(message)
})
}

function hideModal() {
  var x = document.getElementById("share-popup");
    if (x.style.display === "block") {
    x.style.display = "none";
  }
}

function getFeedByLabType(e) {
  let labType = jQuery(e).attr("data-labdiamond") // Getting lab type
  let diamondType = getParameterByName('diamondType') // Getting parameter by URL
  let getSelectedParameters = getBodyParams() // Getting all selected params
  var keysToRemove = []
  if (labType === "true" && parseInt(getSelectedParameters?.price_total_to) > 50000){
    keysToRemove = keysToRemove.concat(['price_total_to']);
  }
  if (labType === "true" && getSelectedParameters?.size_from < '2.00' && getSelectedParameters?.size_to > '5.00' &&
    getSelectedParameters?.size_from !== '2.00' && getSelectedParameters?.size_to !== '5.00'){
    keysToRemove = keysToRemove.concat(['size_from', 'size_to']);
  }
  removeKeysFromLocalStorage(keysToRemove)

  let newPageUrl = getUrlWithoutDid()
  jQuery("a[data-labdiamond]").removeClass("active") // Removing active class
  jQuery(e).addClass("active") // adding active class
  if (labType && diamondType ) {
    let urlWithPageNumber = updateQueryStringParameter(newPageUrl, 'page', 1)            
    if ( labType == "true" ) {
      bodyToSend.lg = true
      bodyToSend.price_total_from = minLabGrownDiamondPrice;
      bodyToSend.price_total_to = maxLabGrownDiamondPrice
      let str = updateQueryStringParameter(urlWithPageNumber, 'diamondLabType', 'lab')            
      history.pushState({}, "", str)
    } else {
      bodyToSend.lg = false
      bodyToSend.price_total_from = minNaturalDiamondPrice;
      bodyToSend.price_total_to = maxNaturalDiamondPrice
      let str = updateQueryStringParameter(urlWithPageNumber, 'diamondLabType', 'natural')            
      history.pushState({}, "", str)
    }
    // Calling this function because we have to reset the filters
    var allDiamondValueToSend = toggleDiamond(diamondType)
    if ( allDiamondValueToSend.length > 0 && allDiamondValueToSend.every(v => ['Antique-Style Cushion', 'Antique-Style Round'].includes(v))) {
      // allDiamondValueToSend = ['null'];
    }
    feedOnDiamondChange(allDiamondValueToSend)
  } else {
    console.log("labType is missing")
  }
}

/* This function will remove specific keys from the localstorage object & re-save it */      
function removeKeysFromLocalStorage(keys) {
  var item = localStorage.getItem('_bodyToSend');
  if (item) {
    var data = JSON.parse(item);
      keys.forEach(function(key) {
      delete data[key];
    });
    localStorage.setItem('_bodyToSend', JSON.stringify(data));
  }
}

$(function() {
  var tabindex = 0;
  $('.tabindexfunction,a,input,select').each(function() {
    if (this.type != "hidden") {
      var $input = $(this);
      $input.attr("tabindex", "0");
      tabindex++;
    }
  });
}); 
$("ul").find( ".paginationItem" ).attr('tabindex', 0)

function setDropdownActiveClass(){
  var checkboxes = document.querySelectorAll('#engaged input[type="checkbox"]');
  checkboxes.forEach(function(checkbox) {
    if (defaultDiamondShape.includes(checkbox.value)) {
      checkbox.checked = true;
    }
  });
}

/* Managing Diamond Feed Scroll Behaviour */
document.addEventListener('DOMContentLoaded', () => {
  const tabs = document.querySelectorAll('[role="tab"]');
  const tabPanels = document.querySelectorAll('[role="tabpanel"]');
  tabs.forEach((tab, index) => {
    tab.addEventListener('click', (e) => {
      activateTab(e.currentTarget);
    });
    tab.addEventListener('keydown', (e) => {
      let newIndex;
      switch (e.key) {
        case 'ArrowRight':
          newIndex = (index + 1) % tabs.length;
          tabs[newIndex].focus();
          break;
        case 'ArrowLeft':
          newIndex = (index - 1 + tabs.length) % tabs.length;
          tabs[newIndex].focus();
          break;
        case 'Enter':
        case ' ':
          activateTab(e.currentTarget);
          break;
      }
    });
  });
  function activateTab(tab) {
    // Deactivate all tabs and hide all tabpanels
    tabs.forEach(t => {
      t.setAttribute('aria-selected', 'false');
    });
    tabPanels.forEach(panel => {
      panel.style.display = 'none';
    });
    // Activate the selected tab and show the corresponding tabpanel
    tab.setAttribute('aria-selected', 'true');
    const tabPanel = document.getElementById(tab.getAttribute('aria-controls'));
    if(tabPanel){
      tabPanel.style.display = 'block';
      tabPanel.focus();
    }
  }
  tabs[0].focus();
});